/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["jsonpFunctionUdash"];
/******/ 	window["jsonpFunctionUdash"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({"1":"uheatmap","2":"uplayer"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 
	 * (c) Use It Better, http://useitbetter.com
	 *
	 *
	 * @preserve
	 */
	function getScriptUrl(){
	    var source = document.querySelector('script[src*="udash."]').getAttribute('src');
	    var name = source.split('/').pop(); 
	    return source.replace(name,"");    
	}
	
	__webpack_require__.p = getScriptUrl();
	
	;(function(win) { // win === window
	
	    if (win.uDash) {
	        console.error("Attempt to initiate uDash terminated. It's been already initiated.");
	        return;
	    }
		'use strict';
	    
		// object performing tests to determine if the browser is capable of handling uDash
		var _capabilities = {
	
			result: [],
	
			tests: { // test cases returning boolean value for passed or failed test
				'Element.addEventListener': function() {
					return	'addEventListener' in win;
				},
				'Date.now': function() {
					return 'now' in win.Date;
				},
				'String.trim': function() {
					return 'trim' in win.String.prototype;
				},
				'JSON': function() {
					return 'JSON' in win;
				},
				'localStorage': function() {
					return 'localStorage' in win;
				},
				'sessionStorage': function() {
					return 'sessionStorage' in win;
				},
				'Canvas.getContext': function() {
					return 'getContext' in win.document.createElement('canvas');
				}
			},
	
			check: function() {
				var name;
	
				for(name in this.tests) {
					if(this.tests.hasOwnProperty(name) && this.tests[name]() === false) { // failure
						this.result.push(name); // push failed test name into result array
					}
				}
	
				return this.result.length === 0; // if result array is empty then all the tests passed
			},
	
			getResult: function() {
				return this.result.join(', ');
			}
	
		};
	
	
		/* and here we go... */
	
		// before even publishing uDash object into global namespace, check browser capability
		if(_capabilities.check()) {
	        
	        var uShared = __webpack_require__(1);
	        
			var _publisher = {
	
				_uDashInitOptions: {},
	
				_inject: function(options) {
	
					if(uShared._sstorage.get('uDebug')) { 
						if(typeof uShared._uConsole.log === 'undefined') {
							uShared._uConsole.init(true);
						}
					} 
					// determine which object inject as uDash into global namespace
					if(uShared._sstorage.get('uHeatMapData')) { // uHeatMapData specified in url or saved in session, inject uHeatMap 
						if(typeof uShared._uConsole.log === 'undefined') {
							uShared._uConsole.init(true);
						}
	                    
	                    win.uDash = __webpack_require__(2);
					    win.uDash.init.call(win.uDash, options);   
	                               
	                    __webpack_require__.e/* nsure */(1, function(require) {
	                        var uHeatMap = __webpack_require__(3);
	                        win.uHeatMap = uHeatMap;
						    uHeatMap.init.call(win.uDash, options);
	                    });
	                    
					}
					else if(uShared._sstorage.get('uSessionHash') && uShared._sstorage.get('uProjectHash')) {
	                    __webpack_require__.e/* nsure */(2, function(require) {
	                        var uPlayer = __webpack_require__(4);
						    win.uDash = uPlayer;
	                        win.uDash.init.call(win.uDash, options);
	                    });
					}
					else { // no uParams specified, inject uRecorder
						win.uDash = __webpack_require__(2);
	                    win.uDash.init.call(win.uDash, options);
					}
	                win.uDash.shared = uShared;
				},
	
				_checkMessage: function(e) {
	
					var	data = e.data,
						params = e.data.params;
	
					if(data && data.uDashMessage === true && params && typeof params.uParams === 'object') {
	
						uShared._timeouts.clear('publishTimeout');
						win.removeEventListener('message', _publisher._checkMessage);
						uShared._uParams.loadFromJSON(params.uParams);
	
						_publisher._inject(_publisher._uDashInitOptions);
					
					}
			
				},
	
				run: function() {
	
					var that = this;
	
					win.uDash = {
						
						META_ACTION: uShared.META_ACTION,
						META_SECTION: uShared.META_SECTION,
						META_ERROR: uShared.META_ERROR,
						META_SITE_IS_READY: uShared.META_SITE_IS_READY,
	
						init: function(options) {
	                        if (win.location.href.indexOf('uSessionHash')>1){
	                            options.uAllowCookies=true;
	                        }
							var bkp;
	
							that._uDashInitOptions = options;
	                        uShared._defaults = uShared._extend(uShared._defaults,options);
	
							if(!uShared._uParams.loadFromUrl()) {
								
								// try to get backup data from storage if there is any
								if(
									options.uProjectName && options.uPort && options.uProjectApiPass &&
									(bkp = uShared._sstorage.getBackup(options.uProjectName, options.uPort, options.uProjectApiPass))
								) {
									// there is a valid recorder backup set	
	                                if (bkp){
	                                    if (bkp['inthesample']) uShared._lstorage.set('inthesample',bkp['inthesample']);
	                                    if (bkp['outofsample']) uShared._lstorage.set('outofsample',bkp['outofsample']);
	                                    if (bkp['userID']) uShared._lstorage.set('userID',bkp['userID']);
	                                    if (bkp['userVisit']) uShared._lstorage.set('userVisit',bkp['userVisit']);
	                                    if (bkp['logDumpToken']) uShared._sstorage.set('logDumpToken',bkp['logDumpToken']);
	                                    if (bkp['timeOffset']) uShared._sstorage.set('timeOffset',bkp['timeOffset']);
	                                    if (bkp['uDebug']) uShared._sstorage.set('uDebug',bkp['uDebug']);
	                                }
	
								}
								if(win !== win.top) { // current document is in nested frame, possibly a replay, try getting data
									try {
	
										
	                                    // origins are not the same, poll for possibility of communication
	                                    win.addEventListener('message', that._checkMessage, false);
	
	                                    win.parent.postMessage({
	                                        uDashMessage: true,
	                                        name: 'requestUParams'
	                                    }, '*');
	
	                                    // after 150ms it's unlikely that parent frame is a uPlayerWrapper and didn't respond yet, proceed with initialization
	                                    uShared._timeouts.set('publishTimeout', function() {
	
	                                        that._inject(options);
	
	                                    }, 150);
										
									} //Access violation
									catch (err) {
										uShared._uConsole.log ('frame access',err);
										//document.domain = window.location.hostname.replace('www.', '');
										win.parent.postMessage({
											uDashMessage: true,
											name: 'changeDomain',
											href: window.location.href
										}, '*');
										
										setTimeout(win.uDash.init,500,options);
										return;
									}
								}
								else { // current document is a top frame
									that._inject(options);
								}
							}
							else { // no params loaded from URL
								that._inject(options);
							}
							
						},
						getSetting: function(name) {
							return uShared._defaults[name] || '';
						},
						getStatus: function() {
							return 'notready';
						},
						tearDown: function() { },
						saveAttribute: function() { },
						saveMeta: function() { },
						sendDump: function() { }
					};
					
				}
			};
	
			_publisher.run();
	
			
		}
		else { // if capability test failed, notify developer and inject blank object in order to not cause any errors
			
			if(win.console && win.console.log) {
				win.console.log('uDash: this browser is incapable of handling uDash properly. Failed support test(s) for: ' + _capabilities.getResult());
			}
	
			win.uDash = {
				META_ACTION: '',
				META_SECTION: '',
				META_ERROR: '',
				META_SITE_IS_READY: '',
	
				init: function() { },
				getSetting: function(name) {
					return '';
				},
				getStatus: function() {
					return 'incompatible';
				},
				tearDown: function() { },
				saveAttribute: function() { },
				saveMeta: function() { },
				sendDump: function() { }
			};
		}
	
	}(window)); // passing global object as '"win"


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /** methods and properties shared across more than one tool **/
	    var uShared = (function (win) {
	        
	        var uShared = {
	
	            // pseudo-constants
	            META_ACTION: 'Action',
	            META_SECTION: 'Section',
	            META_ERROR: 'Error',
	
	            _version: 'uDash JS 3.2.13', // app version
	
	            // app status
	            // notready  - no handlers have been attached and no storage data has been set
	            // setup - during attachment of handlers and setting storage data
	            // ready - all handlers attached and storage data set, ready to record, not connected yet
	            // connected - connected to UiB server, up & running
	            // teardown - during the process of tearing down
	            _status: ['notready', 'setup', 'ready', 'connected', 'teardown'][0],
	            _heatmapstatus: ['notready', 'setup', 'ready', 'connected', 'teardown'][0],
	            _defaults: {
	
	                _assetsPath: 'https://uibcdn.com/html_includes/',
	                _apiUrl: 'http://api.useitbetter.com/',
	                _apiUrlSSL: 'https://apigl.useitbetter.com/',
	                _panelPath: 'https://app.useitbetter.com/',
	
	                uDumpProtocole: 'https:',
	                cdnDomain: 'uibcdn.com',
	                uDumpDomain: 'l.useitbetter.com',
	                uDumpMethod: 'pushFileAppendData.php',
	
	                uProjectName: '',
	                uPort: '',
	                uProjectApiPass: '',
	
	                uAllowCookies: true,
	                uAllowTriggerCookies: true,
	                uAllowTracking: true,
	                uForceTracking: 0,
	                uRecordInteractiveEvents: true,
	                uRecordFormSubmit: true,
	                uRecordHashChange: true,
	                uRecordParamsChange: false,
	                uRecordUrlChange: true,
	                uRecordPageChanges: false,
	                uRecordPageChangesAfterEvent: 'click',
	                uRecordCookies: false,
	                maskTagContentSelectors: ['[udash-mask-content="1"]'],
	                /*maskTagAttributeSelectors: ['[udash-mask-attributes="value"]'],*/
	                uIncludeHostnameInSection: false,
	                uCompressDump: false,
	                uRecordFrames: false,
	                uRecordPointerChange: 200,
	                uIgnoreEvents: {},
	                uFullElementBacktrace: false,
	                uIgnoreClassNamesWithPrefix: ['ng-', 'box-'],
	                uIgnoreIdsWithPrefix: ['tui_'],
	                uPackageLimit: 40,
	                uSendTimeout: 5,
	                uShowConsoleMessages: false,
	                uShowEventsTraceInConsole: false,
	                uSample: 0,
	                uTrackingMode: 'SESSIONS',
	                uUseDefaultPanelOpener: false,
	                uEmptySendLimit: 300,
	                uKeepConnection: false,
	                uRecordAjax: false,
	                uCrossSiteSessionsEnabled: true,
	                uCrossSiteSameDomain: true,
	                uTriggersEnabled: true,
	                uTriggersMarking: false,
	                uTriggersTimeout: 2500,
	                uTriggersCheckInterval: 100,
	                uAllowTriggersInNotRecordedSessions: true,
	                uDotSize: 28,
	                uHeatMapOpacity: 190,
	                uHeatMapGradient: { // color palette gradient
	                    0.05: '#35267b',
	                    0.10: '#3f1e7b',
	                    0.15: '#49087f',
	                    0.20: '#5c0872',
	                    0.25: '#78085d',
	                    0.30: '#91084c',
	                    0.35: '#a7083c',
	                    0.40: '#b8082f',
	                    0.45: '#ca0822',
	                    0.50: '#d61119',
	                    0.55: '#d73319',
	                    0.60: '#d75919',
	                    0.65: '#d78219',
	                    0.70: '#d7a919',
	                    0.75: '#d7ba1a',
	                    0.80: '#d7cc1c',
	                    0.85: '#d7d446',
	                    0.90: '#d7d479',
	                    0.95: '#d7d4ae',
	                    1: '#d7d4e5'
	                },
	                uHeatMapStyles: {}, // styles that will be set on canvas element
	
	                uAjaxCacheFlag: 'cacheFromUser',
	                uSkipTimeThreshold: 7,
	
	                uWrapperSelector: '',
	
	                // callbacks
	                onReady: function () {},
	                onConnected: function () {},
	                onTeardown: function () {},
	                onDumpSend: function () {}
	            },
	
	            // temporary cache for cookies and analytics data
	            _unsavedCookies: {},
	            _unsentEvents: [],
	
	            // number determining how many times uDash should reattempt ajax request in case of failure
	            _failedRequestRetry: 20,
	
	            // number of failed ajax requests
	            _failedRequests: 0,
	
	            // number of failed setup attempts
	            _failedSetups: 0,
	
	            _isIE9: win.navigator.userAgent.indexOf('MSIE 9') > -1, // temporary browser sniff, upgrade to feature detection later
	
	            _isIE9Mobile: win.navigator.userAgent.indexOf('MSIE 9') > 1 && win.navigator.userAgent.indexOf('Mobile') > 1,
	
	            _isTouchSupported: 'ontouchstart' in win,
	
	            _recordsSeparator: '\n', // what character is used to separate records 
	
	            _lstorage: {}, // localStorage wrapper, initialized after definition
	
	            _sstorage: {}, // sessionStorage wrapper, initialized after definition 
	
	            _winEventListenerCapture: {}, // spy for all event listeners set on window
	
	            _docEventListenerCapture: {}, // spy for all event listeners set on document
	
	            _htmlEventListenerCapture: {}, // spy for all event listeners set on any HTML element
	
	            // Storage wrapper constructor for namespacing storage data as uDash.*
	            _UStorage: (function () {
	
	                var UStorage = function (storageObject) {
	                    this.temp = {};
	                    this.storageObject = storageObject;
	                    for (var item in storageObject){
	                        if (item.indexOf('uDash.')===0){
	                            this.temp[item.substr(6)] = storageObject.getItem(item);
	                        }
	                    }
	                };
	
	                UStorage.prototype = {
	
	                    set: function (name, value) {
	                        if (!win.uDash.getSetting('uAllowCookies')) {
	                            this.temp[name] = value;
	                            return;
	                        }
	                        var obj,
	                            loopName;
	
	                        if (typeof name === 'object') {
	                            obj = name;
	                            for (loopName in obj) {
	                                if (obj.hasOwnProperty(loopName)) {
	                                    this.set(loopName, obj[loopName]);
	                                }
	                            }
	                        } else {
	                            if (name.match(/^uDash\./)) {
	                                name = name.replace('uDash.', '');
	                            }
	                            return this.storageObject.setItem('uDash.' + name, value);
	                        }
	                    },
	
	                    get: function (name) {
	                        if (!win.uDash.getSetting('uAllowCookies')) {
	                            return this.temp[name] || '';
	                        }
	                        return this.storageObject.getItem('uDash.' + name);
	                    },
	
	                    remove: function (name) {
	                        if (!win.uDash.getSetting('uAllowCookies')) {
	                            delete this.temp[name];
	                            return;
	                        }
	                        return this.storageObject.removeItem('uDash.' + name);
	                    },
	
	                    enable: function () {
	                        for (var name in this.temp) {
	                            this.set(name, this.temp[name]);
	                            delete this.temp[name];
	                        }
	                    },
	
	
	
	                    // make backup copy of the storage and put it into window.name property
	                    // that property behaves somewhat like a sessionStorage but without url restraints,
	                    // so by setting data on it we're able to record sessions based on initialization data (project, port, password)
	                    // and not be tied to a particular address (not even a domain, like in case of cookies)
	                    makeBackup: function (projectName, projectPort, projectApiPass) {
	                        if (win.uDash._globalSettings && !win.uDash._globalSettings.uAllowCookies) {
	                            return;
	                        }
	                        if (win.uDash._globalSettings && !win.uDash._globalSettings.uCrossSiteSessionsEnabled) {
	                            uShared._uConsole.log('uRecorder: cross-site/domain tracking disabled');
	                            return;
	                        }
	                        try {
	                            var /*name,*/
	                                values = {},
	                                arr = [],
	                                leftSide = '',
	                                rightSide = '',
	                                backupString = '',
	                                replaceString = '@#@';
	
	
	
	
	                            values['userID'] = win.localStorage.getItem('uDash.userID');
	
	                            if (!values['userID']) return;
	
	                            values['userVisit'] = win.localStorage.getItem('uDash.userVisit');
	
	                            // this is stored in cookies, but won't work if top domain changes
	                            if (!win.uDash._globalSettings.uCrossSiteSameDomain) {
	                                values['uDashIn'] = win.localStorage.getItem('uDash.in');
	                                values['uDashOut'] = win.localStorage.getItem('uDash.out');
	                            }
	
	                            // continue recording to same session 
	                            if (win.udashSessionToken) values['logDumpToken'] = win.udashSessionToken;
	                            values['timeOffset'] = win.sessionStorage.getItem('uDash.timeOffset');
	
	                            // stay in live/preview mode 
	                            var debug = win.sessionStorage.getItem('uDash.uDebug');
	                            if (debug) values['uDebug'] = debug;
	
	                            arr = win.name.split('%p%' + projectApiPass + '%p%');
	
	                            /*for (name in this.storageObject) {
	                                if (name.match(/^uDash\./)) {
	                                    // skip larger variables to avoid window.name overload.
	                                    switch (name) {
	                                    case 'uDash.dump':
	                                    case 'uDash.tempDump':
	                                    case 'uDash.path':
	                                    case 'uDash.triggers':
	                                        break;
	                                    default:
	                                        values[name] = this.storageObject.getItem(name);
	                                    }
	                                }
	                            }*/
	
	                            if (arr.length > 1) {
	                                leftSide = arr[0] + '%p%' + projectApiPass + '%p%';
	                                rightSide = arr[1].substr(arr[1].indexOf('%e%'), arr[1].length - 1);
	                                backupString = leftSide + replaceString + rightSide;
	                            } else {
	                                backupString += '%s%' + [projectName, projectPort, projectApiPass, replaceString].join('%p%') + '%e%';
	                            }
	
	                            win.name = backupString.replace(replaceString, JSON.stringify(values));
	
	                        } catch (e) {
	                            uShared._uConsole.log('uRecorder: backup failed with error:', e);
	                        }
	                    },
	
	                    // restoring backup, if backup is found it is deleted before returning
	                    getBackup: function (projectName, projectPort, projectApiPass) {
	                        var backupParts,
	                            backupObj,
	                            match = win.name.match(/\%s\%.+\%e\%/),
	                            i,
	                            isFromCookie = false;
	                        try {
	                            if (!match) {
	                                var backupCookie = uShared._readCookie('uDashBackup');
	                                if (backupCookie) match = unescape(backupCookie).match(/\%s\%.+\%e\%/);
	
	                                if (!match) {
	                                    match = [];
	                                } else {
	                                    isFromCookie = true;
	                                }
	                            }
	
	                            // notice: there can be multiple projects data stored in one session, we don't want them to collide
	                            for (i = 0; i < match.length; i++) {
	
	                                backupParts = (match[i].split('%s%')[1].split('%e%')[0]).split('%p%');
	                                if (
	                                    backupParts.length === 4 && backupParts[0] === projectName
	                                ) {
	
	                                    backupObj = JSON.parse(backupParts[3]);
	                                    if (isFromCookie) {
	                                        if (backupObj['uDash.currentUrl'] && uShared._domainChanged(win.location.href, backupObj['uDash.currentUrl'])) {
	                                            //console.log('uRecorder: Backup retrieved from cookie',backupObj);                                                    
	                                        } else {
	                                            //console.log('uRecorder: Domain did not change, ignore backup from cookie',win.location.href,backupObj['uDash.currentUrl']);
	                                            return false;
	                                        }
	                                    }
	                                    return backupObj;
	
	                                }
	                            }
	                        } catch (e) {
	                            if (typeof uDash !== 'undefined' && uDash.saveMeta) uDash.saveMeta('recording alert', 'could not read backup');
	                            setTimeout(function () {
	                                if (typeof uDash !== 'undefined' && uDash.saveMeta) uDash.saveMeta('recording alert', 'could not read backup')
	                            }, 3000);
	
	                            backupObj = {};
	                            return false;
	                        }
	                        return false;
	
	                    },
	
	                    clear: function (options) {
	                        options = options || {};
	
	                        var name;
	                        for (name in this.storageObject) {
	                            if (name.match(/^uDash\./)) {
	                                if (!options.except || options.except.indexOf(name.replace('uDash.', '')) === -1) {
	                                    this.storageObject.removeItem(name);
	                                }
	                            }
	                        }
	                    }
	                };
	
	                return UStorage;
	
	            }()),
	
	            // spy that watches event listeners being set or removed on given element or object
	            _UEventListenerCapture: (function () {
	
	                // private, all the event listeners set on watched elements and objects 
	                var _allEvents = {
	
	                    registered: [],
	
	                    add: function (target, name, handler, useCapture) {
	                        this.registered.push({
	                            target: target,
	                            name: name,
	                            handler: handler,
	                            useCapture: useCapture
	                        });
	                    },
	
	                    remove: function (target, name, handler) {
	
	                        var i;
	
	                        for (i = 0; i < this.registered.length; i++) {
	                            if (
	                                this.registered[i].target === target &&
	                                this.registered[i].name === name &&
	                                this.registered[i].handler === handler
	                            ) {
	                                this.registered.splice(i, 1);
	
	                                return i;
	                            }
	                        }
	
	                        return -1;
	
	                    }
	
	                };
	
	                //	constructor method for objects that serve as a public interface for spyed objects and elements
	                var _UEventListenerCapture = function (target) {
	
	                    this.target = target;
	                    this.augmentTarget = (typeof target.prototype !== 'undefined' && typeof target.prototype.addEventListener !== 'undefined') ? target.prototype : target;
	
	                    // augmentation of original addEventListener, adding one extra parameter - if set to true, listener is not registered in _allEvents object
	                    (function (obj, addEventListener) {
	
	                        obj.addEventListener = function (name, handler, useCapture, ignore) {
	
	                            if (!ignore) {
	                                _allEvents.add(this, name, handler, useCapture);
	                            }
	
	                            // pass into original addEventListener
	                            return addEventListener.call(this, name, handler, useCapture);
	                        };
	
	                    }(this.augmentTarget, this.augmentTarget.addEventListener));
	
	
	                    // augmentation of original removeEventListener, adding one extra parameter - if set to true, listener is not removed from _allEvents object
	                    (function (obj, removeEventListener) {
	
	                        obj.removeEventListener = function (name, handler, ignore) {
	
	                            if (!ignore) {
	                                _allEvents.remove(this, name, handler);
	                            }
	
	                            // pass into original addEventListener
	                            return removeEventListener.call(this, name, handler);
	
	                        };
	
	
	                    }(this.augmentTarget, this.augmentTarget.removeEventListener));
	
	                };
	
	                _UEventListenerCapture.prototype = {
	
	                    // add all captured listeners for a observed element	
	                    addAll: function (name) {
	
	                        var i;
	
	                        for (i = 0; i < _allEvents.registered.length; i++) {
	
	                            if (
	                                (typeof this.target === 'object' && _allEvents.registered[i].target === this.target) ||
	                                (typeof this.target === 'function' && _allEvents.registered[i].target instanceof this.target)
	                            ) {
	                                this.target.addEventListener(
	                                    _allEvents.registered[i].name,
	                                    _allEvents.registered[i].handler,
	                                    _allEvents.registered[i].useCapture,
	                                    true
	                                );
	                            }
	                        }
	
	                    },
	
	                    // remove all captured listeners from observed element
	                    removeAll: function () {
	
	                        var i;
	
	                        for (i = 0; i < _allEvents.registered.length; i++) {
	                            if (
	                                (typeof this.target === 'object' && _allEvents.registered[i].target === this.target) ||
	                                (typeof this.target === 'function' && _allEvents.registered[i].target instanceof this.target)
	                            ) {
	                                this.target.removeEventListener(
	                                    _allEvents.registered[i].name,
	                                    _allEvents.registered[i].handler,
	                                    true
	                                );
	                            }
	                        }
	
	                    }
	                };
	
	                return _UEventListenerCapture;
	
	            }()),
	
	            _apiManager: {
	
	                apiHost: '',
	                apiHostSSL: '',
	                apiProjectAuthKey: '',
	                apiAccountAuthKey: '',
	                projectHash: '',
	
	                getApiUrl: function () {
	
	                    var isHttps = (win.location.protocol === 'https:'),
	                        uApiUrl = uShared._sstorage.get('uApiUrl');
	
	                    if (uApiUrl) {
	                        return uApiUrl;
	                    } else if (isHttps) {
	                        return this.apiHostSSL || uShared._defaults._apiUrlSSL;
	                    } else {
	                        return this.apiHost || uShared._defaults._apiUrl;
	                    }
	                },
	
	                cache: {
	                    data: {},
	
	                    createIndex: function () {
	                        return JSON.stringify(Array.prototype.slice.call(arguments));
	                    },
	
	                    storeObject: function () {
	                        var args = Array.prototype.slice.call(arguments),
	                            data = args.shift(),
	                            index = this.createIndex.apply(this, args);
	
	                        this.data[index] = data;
	
	                    },
	
	                    getObject: function () {
	                        var index = this.createIndex.apply(this, Array.prototype.slice.call(arguments));
	                        if (this.data.hasOwnProperty(index)) {
	                            return this.data[index];
	                        } else {
	                            return false;
	                        }
	                    }
	
	                },
	
	                send: function (options) {
	
	                    var that = this,
	                        data = options.data || {},
	                        cacheObject;
	
	
	
	                    if (typeof options.method !== 'string') {
	                        uShared._uConsole.error('API: Specify api call method');
	                    }
	
	                    if (this.apiAccountAuthKey && [this.ACCOUNT_PROJECT_LOGIN, this.ACCOUNT_PROJECT_LIST].indexOf(options.method) > -1) {
	                        data.apiAccountAuthKey = this.apiAccountAuthKey;
	                    } else if (this.apiProjectAuthKey && options.method !== this.ACCOUNT_LOGIN) {
	                        data.apiAuthKey = this.apiProjectAuthKey;
	                    }
	                    data.getRequest = 1;
	
	                    cacheObject = this.cache.getObject(options, data);
	
	                    if ((options.cache && options.cache === false) || !cacheObject) {
	
	                        return uShared._ajax({
	                            url: that.getApiUrl() + options.method,
	                            method: 'POST',
	                            data: data,
	                            success: function (response) {
	                                try {
	                                    response = JSON.parse(response);
	                                    that.cache.storeObject(response, options, data);
	                                } catch (e) {
	                                    response = {};
	                                }
	
	                                return options.success(response);
	                            }
	                        });
	                    } else if (cacheObject) {
	                        return options.success(cacheObject);
	                    }
	                }
	
	            },
	
	            // shortener/expander of property names in Events, used to reduce amount of data pushed through wire
	            _propertyNames: {
	
	                _map: {
	                    kC: 'keyCode',
	                    cX: 'clientX',
	                    cY: 'clientY',
	                    pX: 'pageX',
	                    pY: 'pageY',
	                    sX: 'screenX',
	                    sY: 'screenY',
	                    id: 'identifier',
	                    t: 'touches',
	                    tT: 'targetTouches',
	                    cT: 'changedTouches'
	                    /*,
	                    							chk: 'checkTag'*/
	                },
	
	                _iterator: function (obj, getter) {
	                    var name,
	                        i,
	                        mapName,
	                        newObj;
	
	                    if (Array.isArray(obj)) {
	                        newObj = [];
	                        for (i = 0; i < obj.length; i++) {
	                            if (typeof obj[i] === 'object') {
	                                newObj[i] = this._iterator(obj[i], getter);
	                            } else {
	                                newObj[i] = obj[i];
	                            }
	                        }
	                    } else {
	                        newObj = {};
	                        for (name in obj) {
	                            if (obj.hasOwnProperty(name)) {
	                                mapName = getter(name);
	
	                                if (typeof obj[name] === 'object') {
	                                    newObj[mapName] = this._iterator(obj[name], getter);
	                                } else {
	                                    newObj[mapName] = obj[name];
	                                }
	                            }
	                        }
	                    }
	
	                    return newObj;
	
	                },
	
	                getShortName: function (name) {
	                    var mapName;
	                    for (mapName in this._map) {
	                        if (this._map.hasOwnProperty(mapName) && this._map[mapName] === name) {
	                            return mapName;
	                        }
	                    }
	                    return name;
	                },
	
	                getLongName: function (name) {
	                    return this._map[name] || name;
	                },
	
	                shorten: function (obj) {
	
	                    return this._iterator(obj, uShared._bindShim(this.getShortName, this));
	
	                },
	
	                expand: function (obj) {
	
	                    return this._iterator(obj, uShared._bindShim(this.getLongName, this));
	
	                }
	            },
	
	            // little shim for Function.prototype.bind (due to older android 2.3 browser's implementation problems - drop it when system becomes outdated)
	            _bindShim: function () {
	
	                var args = Array.prototype.slice.call(arguments),
	                    func = args.shift(),
	                    ctx = args.shift();
	
	                return function () {
	                    return func.apply(ctx, arguments);
	                };
	            },
	
	            _selectorMatch: function (selectorString, element, parent) {
	
	                if (!parent) {
	                    parent = win.document;
	                }
	
	                var i,
	                    check = parent.querySelectorAll(selectorString);
	
	                for (i = 0; i < check.length; i++) {
	                    if (check[i] === element) {
	                        return true;
	                    }
	                }
	
	                return false;
	
	            },
	
	            // deep extension of one object by another
	            _extend: function () {
	
	                var args = Array.prototype.slice.call(arguments),
	                    base = args.shift(),
	                    extend,
	                    prop,
	                    i;
	
	                for (i = 0; i < args.length; i++) {
	
	                    extend = args[i];
	
	                    for (prop in extend) {
	                        if (extend.hasOwnProperty(prop)) {
	                            if (typeof extend[prop] === 'object' && !Array.isArray(extend[prop])) {
	
	                                if (base.hasOwnProperty(prop)) {
	                                    base[prop] = uShared._extend(base[prop], extend[prop]);
	                                } else {
	                                    base[prop] = uShared._extend({}, extend[prop]);
	                                }
	                            } else {
	                                try {
	                                    base[prop] = extend[prop];
	                                } catch (e) {}
	                            }
	                        }
	                    }
	                }
	
	                return base;
	
	            },
	
	            // getter for application status
	            getStatus: function () {
	                return this._status;
	            },
	
	            disableCookies: function () {
	                win.uDash._globalSettings.uAllowCookies = false;
	                uShared._clearCookie('uDashIn');
	                uShared._clearCookie('uDashOut');
	                uShared._sstorage.clear();
	                uShared._lstorage.clear();
	                return true;
	            },
	            enableCookies: function () {
	                if (!win.uDash._globalSettings.uAllowCookies) {
	                    win.uDash._globalSettings.uAllowCookies = true;
	
	                    for (var name in win.uDash.shared._unsavedCookies) {
	                        var c = win.uDash.shared._unsavedCookies[name];
	                        uShared._setCookie(c.name, c.value, c.expires);
	                    }
	                    win.uDash.shared._unsavedCookies = {};
	                    uShared._sstorage.enable();
	                    uShared._lstorage.enable();
	                }
	                return true;
	            },
	
	            enableTracking: function () {
	                if (!win.uDash._globalSettings.uAllowTracking) {
	                    /*
	                    if ( !win.uDash._globalSettings.uAllowCookies ) {
	                        uShared._uConsole.log('uRecorder: cookies must be enabled to enable tracking');
	                        return false;
	                    }
	                    */
	                    win.uDash._globalSettings.uAllowTracking = true;
	                    win.uDash.connect();
	                }
	                return true;
	            },
	
	            // attachment of event handlers in useCapture mode
	            // win_* - handlers attached on window
	            // doc_* - handlers attached on window.document
	            _attachEventHandlers: function (handlers, settings, customTarget) {
	                var i, handlerTarget, handlerName;
	
	                for (i in handlers) {
	                    
	                    if (settings.uIgnoreEvents[i.substr(4)]) {
	                        continue;
	                    }
	                    /*if (window.location.pathname.indexOf('checkout3')>-1 && i.indexOf('touch')>-1){
	                        continue;
	                    }*/
	                    if (handlers.hasOwnProperty(i)) {
	                        if (!customTarget) {
	                            if (i.match(/^doc\_/)) {
	                                handlerTarget = win.document;
	                                handlerName = i.replace('doc_', '');
	                            } else if (i.match(/^win\_/)) {
	                                handlerTarget = win;
	                                handlerName = i.replace('win_', '');
	                            } else {
	                                handlerTarget = null;
	                            }
	                            if (handlerTarget) {
	                                handlerTarget.addEventListener(handlerName, handlers[i], true);
	                            }
	                        } else {
	                            if (i.match(/^doc\_/)) {
	                                handlerName = i.replace('doc_', '');
	                                customTarget.addEventListener(handlerName, handlers[i], true);
	                            }
	                        }
	
	                    }
	                }
	            },
	
	            // detachment of event handlers
	            _detachEventHandlers: function (handlers) {
	
	                var i, handlerTarget, handlerName;
	
	                for (i in handlers) {
	                    if (handlers.hasOwnProperty(i)) {
	                        if (i.match(/^doc\_/)) {
	                            handlerTarget = win.document;
	                            handlerName = i.replace('doc_', '');
	                        } else if (i.match(/^win\_/)) {
	                            handlerTarget = win;
	                            handlerName = i.replace('win_', '');
	                        } else {
	                            handlerTarget = null;
	                        }
	
	                        if (handlerTarget) {
	                            handlerTarget.removeEventListener(handlerName, handlers[i]);
	                        }
	                    }
	                }
	            },
	
	            // convenience method for getting document's width and height
	            _getDocumentSize: function () {
	                return {
	                    width: win.document.documentElement.scrollWidth,
	                    height: win.document.documentElement.scrollHeight
	                };
	            },
	
	            // get viewport size
	            _getWindowSize: function () {
	                return {
	                    width: win.document.documentElement.clientWidth,
	                    height: win.document.documentElement.clientHeight
	                };
	            },
	
	            // get scroll offset of the document
	            _getScroll: function () {
	                var doc = win.document.documentElement,
	                    body = win.document.body;
	
	                return {
	                    x: doc && doc.scrollLeft || body && body.scrollLeft || 0,
	                    y: doc && doc.scrollTop || body && body.scrollTop || 0
	                };
	            },
	
	            // get document scale information
	            _getDocumentScale: function () {
	                var viewportScale = undefined,
	                    screenWidth = win.innerWidth;
	
	                if (win.orientation) {
	                    screenWidth = screen.width; //eq. with window.screen
	                    if (win.orientation === 'portrait') {
	                        if (screen.width > screen.height) {
	                            screenWidth = screen.height;
	                        }
	                    } else {
	                        if (screen.width < screen.height) {
	                            screenWidth = screen.height;
	                        }
	                    }
	                    viewportScale = screenWidth / win.innerWidth;
	                } else {
	                    viewportScale = 1; // always 1 for desktop            
	                }
	
	                return viewportScale;
	            },
	
	            // console self-overwriting wrapper
	            _uConsole: {
	                init: function (showMessages) {
	                    
	                    if (win.console && showMessages) {
	                        uShared._uConsole = win.console;
	                    } else {
	                        uShared._uConsole = {
	                            log: function () {},
	                            error: function () {},
	                            warn: function () {}
	                        };
	                    }
	                }
	            },
	
	            // timeouts wrapper, used to keep track of timeouts and conveniently clear all of them during teardown
	            _timeouts: {
	
	                current: {},
	
	                // set timeout
	                set: function (name, func, delay) {
	                    var that = this,
	                        altName = name,
	                        i = 0;
	
	                    // if there already is a timeout with that name, search for next free name
	                    if (typeof this.current[name] === 'number') {
	                        do {
	                            altName = name + '.' + i;
	                            i += 1;
	                        } while (typeof this.current[altName] === 'number');
	                        name = altName;
	                    }
	
	                    this.current[name] = win.setTimeout(function () {
	                        that.clear(name);
	                        func();
	                    }, delay);
	                },
	
	                // clear timeout
	                clear: function (name) {
	                    if (typeof this.current[name] === 'number') {
	                        win.clearTimeout(this.current[name]);
	                        delete this.current[name];
	                    }
	                },
	
	                // clear all timeouts
	                clearAll: function () {
	                    var name;
	                    for (name in this.current) {
	                        if (this.current.hasOwnProperty(name)) {
	                            this.clear(name);
	                        }
	                    }
	                }
	            },
	
	            // dynamic css loader
	            _loadCss: function (file, assetsPath) {
	                var body = win.document.querySelector('body'),
	                    stylesheet;
	
	                if (win.document.createStyleSheet) { // IE model
	                    stylesheet = win.document.createElement('style');
	
	                    // do not use createStyleSheet as it sometimes doesn't work in IE mobile, use ajax instead
	                    this._ajax({
	                        method: 'GET',
	                        url: assetsPath + 'getCrossdomain.php?uStylesheetFile=' + file,
	                        success: function (response) {
	                            stylesheet.appendChild(win.document.createTextNode(response));
	                            body.appendChild(stylesheet);
	                        }
	                    });
	                } else { // standard model
	                    stylesheet = win.document.createElement('link');
	                    stylesheet.setAttribute('rel', 'stylesheet');
	                    stylesheet.setAttribute('href', assetsPath + file);
	                    body.appendChild(stylesheet);
	                }
	
	            },
	
	            // automatic page wrap element finder, used for heatmaps
	            _wrapFinder: {
	
	                _wrapper: null,
	                _levelLimit: 5, // how many levels deep should wrapper be looked for
	                _levelRating: [-3, 0, -1, -1, -2, -2, -3, -3], // amount of rating score each level decreases
	                _candidates: [],
	                _compareWidth: 0,
	                _words: [
	       /wrap/i,
	       /contain/i,
	       /conten/i
	      ],
	
	                // size of the body element
	                // if body overflow-x (horizontal scroll) is hidden use clientWidth, otherwise use scrollWidth
	                _getCompareWidth: function () {
	
	                    var htmlStyle = win.getComputedStyle(win.document.documentElement),
	                        bodyStyle = win.getComputedStyle(win.document.body);
	
	                    if (
	                        htmlStyle.overflow === 'hidden' || bodyStyle.overflow === 'hidden' ||
	                        htmlStyle.overflowX === 'hidden' || bodyStyle.overflowX === 'hidden'
	                    ) {
	                        return win.document.body.clientWidth;
	                    } else {
	                        return win.document.body.scrollWidth;
	                    }
	                },
	
	                find: function () {
	
	                    if (!this._wrapper || this._wrapper.getBoundingClientRect().width===0) {
	
	                        this._compareWidth = this._getCompareWidth();
	
	                        this._buildCandidates(win.document.documentElement, 0); // start building candiates list from <html> element
	
	                        this._candidates.sort(function (a, b) { // sort candidates by rating
	                            if (a.rating > b.rating) {
	                                return -1;
	                            } else if (a.rating < b.rating) {
	                                return 1;
	                            } else {
	                                return 0;
	                            }
	                        });
	                        this._wrapper = this._candidates[0].element;
	                    }
	
	                    return this._wrapper;
	                },
	
	                _rateElement: function (element, level) {
	
	                    var rating = 0,
	                        winSize = uShared._getWindowSize(),
	                        offsetLeft = Math.ceil(element.getBoundingClientRect().left + uShared._getScroll().x),
	                        i;
	
	
	                    if (
	                        (element.clientWidth < this._compareWidth && element.clientWidth > this._compareWidth / 2) || // element is smaller than whole document, but larger than half of the document
	                        (element.clientWidth > winSize.width) // or element is larger than viewport
	                    ) {
	                        rating += 10;
	                    }
	                    // element is centered
	                    if (
	                        offsetLeft === Math.ceil((this._compareWidth - element.clientWidth) / 2) ||
	                        offsetLeft === Math.ceil((this._compareWidth - element.clientWidth) / 2) - 1
	                    ) {
	                        rating += 15;
	                    }
	
	                    // element is named in a suggestive way
	                    for (i = 0; i < this._words.length; i++) {
	                        if (element.className && element.className.match && element.className.match(this._words[i])) {
	                            rating += 5;
	                        }
	                        if (element.getAttribute('id') && element.getAttribute('id').match(this._words[i])) {
	                            rating += 7;
	                        }
	                    }
	
	                    rating += this._levelRating[level];
	
	                    return rating;
	
	
	                },
	
	
	                _buildCandidates: function (parent, level) { // go down the DOM tree looking for wrapper candidates
	                    var children = parent.children,
	                        i = 0;
	
	                    if (level < this._levelLimit && children.length > 0) {
	                        for (i = 0; i < children.length; i++) {
	                            if (children[i].nodeType === 1) {
	                                this._candidates.push({
	                                    element: children[i],
	                                    rating: this._rateElement(children[i], level)
	                                });
	                                this._buildCandidates(children[i], level + 1);
	                            }
	                        }
	                    }
	                },
	
	
	
	                // if element is set explicitly via init() options
	                setWrapper: function (element) {
	                    this._wrapper = element;
	                },
	
	                getWrapperOffset: function () {
	                    return Math.floor(this.find().getBoundingClientRect().left + uShared._getScroll().x);
	                }
	
	            },
	
	            // store uParams from URL into an object
	            _uParams: {
	
	                _keysToPreserve: ['apiAuthKey'], // which keys should not be flushed during session storage clear
	
	                loadFromUrl: function () {
	
	                    var paramsLocation,
	                        paramsString = '',
	                        paramsSplit = {},
	                        oneParamSplit = {},
	                        i;
	
	                    if (win.location.search.indexOf('uParams') > -1) {
	                        paramsLocation = win.location.search;
	                    } else if (win.location.hash.indexOf('uParams') > -1) {
	                        paramsLocation = win.location.hash;
	                    }
	
	                    if (paramsLocation) {
	
	                        uShared._sstorage.clear({
	                            except: this._keysToPreserve
	                        });
	
	                        paramsString = decodeURIComponent(decodeURI(paramsLocation)).split('uParams=')[1].split('&')[0];
	                        paramsSplit = paramsString.split('||');
	
	                        for (i = 0; i < paramsSplit.length; i++) {
	                            oneParamSplit = paramsSplit[i].split('@@');
	                            uShared._sstorage.set(oneParamSplit[0], oneParamSplit[1]);
	                        }
	                        return true;
	                    } else {
	                        return false;
	                    }
	                },
	
	                // method used to remove uParams string from the url (used for generating heatmaps and replays from url meta sections)
	                stripFromUrl: function (url) {
	
	                    url = url.replace(/uParams=[a-zA-Z0-9@%\/]+/, '');
	
	                    if (url.indexOf('?#') > -1) { // if uParams were only GET params, remove question mark
	                        url = url.replace('?#', '#');
	                    }
	
	                    if (url.indexOf('?') === url.length - 1) {
	                        url = url.slice(0, url.length - 1);
	                    }
	
	                    if (url !== url) {
	                        var lastChar = url.substr(-1);
	                        if (lastChar === '?' || lastChar === '#') url = url.substr(0, url.length - 1);
	                    }
	
	                    return url;
	                },
	
	                loadFromJSON: function (obj) {
	
	                    if (!obj.toString || obj.toString() !== '[object Object]') {
	                        try {
	                            obj = JSON.parse(obj);
	                        } catch (e) {
	                            obj = {};
	                        }
	                    }
	
	                    uShared._sstorage.clear({
	                        except: this._keysToPreserve
	                    });
	
	
	                    uShared._sstorage.set(obj);
	
	                },
	
	                stringFromObject: function (obj) {
	
	                    var name,
	                        params = [];
	
	                    for (name in obj) {
	                        params.push(name + '@@' + obj[name]);
	                    }
	
	                    return params.join('||');
	
	                }
	            },
	
	            _getMetaSectionAutosaveName: function (settings) {
	
	                var base = settings.uIncludeHostnameInSection ? win.location.hostname + win.location.pathname : win.location.pathname,
	                    search = win.location.search,
	                    hash = win.location.hash,
	                    toSave = '';
	
	                if (base[0] === '/') {
	                    base = base.substr(1);
	                }
	                if (base === '') {
	                    base = 'Home';
	                }
	
	                if (settings.uRecordUrlChange) {
	                    toSave = base;
	                }
	
	                // custom code
	                //toSave=toSave.split(';jsessionid')[0]; 
	                // end of custom code
	
	                if (settings.uRecordParamsChange && search) {
	                    toSave = base + search;
	                }
	                if (settings.uRecordHashChange) {
	                    toSave += hash;
	                }
	
	                if (toSave) {
	                    var section = uShared._prepareUrl(decodeURIComponent(toSave));
	                    //var lastSection = uShared._sstorage.get('lastSection')  || '';;
	                    // custom code
	
	
	                    // end of custom code
	                    toSave = section;
	                }
	
	                if (!settings.uRecordExecutionFlow) {
	                    toSave = toSave.replace(/e+[0-9]+s+[0-9]+/, '');
	                }
	
	                var params = toSave.split('uParams');
	                if (params[1]) {
	                    toSave = params[0];
	                    if (params[1].indexOf('&') > -1) {
	                        toSave += params[1].substr(params[1].indexOf('&') + 1, params[1].length);
	                    }
	                }
	
	                if (toSave /*&& lastSection !== toSave*/ ) {
	                    return toSave;
	                } else {
	                    return '';
	                }
	            },
	
	
	            // url cleaner
	            _prepareUrl: function (url) {
	                if (url.indexOf('#') === url.length - 1) { // there is a trailing hash, remove it
	                    url = url.slice(0, url.length - 1);
	                }
	
	                return url;
	            },
	
	            _encodePOST: function (data) {
	                var name,
	                    value,
	                    encodedData = [];
	
	                for (name in data) {
	                    if (data.hasOwnProperty(name)) {
	                        value = (data[name] || '').toString();
	                        value = encodeURIComponent(value).replace('%20', '+');
	                        name = encodeURIComponent(name).replace('%20', '+');
	                        encodedData.push(name + '=' + value);
	                    }
	                }
	
	                return encodedData.join('&');
	            },
	
	            // generic method for sending data (cross-domain ajax)
	            _ajax: function (options) {
	
	                var xhr,
	                    success = options.success || function () {},
	                    error = options.error || function () {},
	                    data = options.data || {},
	                    url = options.url,
	                    method = options.method || 'POST',
	                    encodedData = '',
	
	                    retryOnError = function () { // retry connection on error
	                        if (uShared.getStatus() !== 'teardown') {
	                            uShared._failedRequests++;
	                            error(xhr);
	                        }
	                        /*
	                        if (uShared.getStatus() !== 'teardown') { // error occurred, but uDash is not being torn down
	                            if (uShared._failedRequests < uShared._failedRequestRetry) { // there are some retry attempts left
	                                uShared._failedRequests++;
	                                uShared._ajax(options);
	                            } else { // no retry attempts left, call error callback
	                                error(xhr);
	                            }
	                        }*/
	                    };
	
	                // encode object into query string
	                if (method === 'POST') {
	                    encodedData = uShared._encodePOST(data);
	                }
	
	                // send data
	                if ('XDomainRequest' in win) { // IE cross-domain request
	                    xhr = new XDomainRequest();
	                    xhr.onprogress = function () {};
	                    xhr.onload = function () {
	                        success(xhr.responseText);
	                    };
	                    xhr.onerror = function () {
	                        retryOnError();
	                    };
	                } else if ('XMLHttpRequest' in win) { // standard cross-domain request
	                    xhr = new XMLHttpRequest();
	                    xhr.onreadystatechange = function () {
	                        if (xhr.readyState === 4) {
	                            if (xhr.status === 200) { // success
	                                uShared._failedRequests = 0;
	                                success(xhr.responseText);
	                            } else {
	                                retryOnError();
	                            }
	                        }
	                    };
	                } else {
	                    uShared._uConsole.error('uDash: no asynchronous transport method available');
	                }
	
	                xhr._uibRequest = true; // mark request as UiB internal in order to not record it
	
	                try {
	                    xhr.open(method, url);
	                    if (method === 'POST') {
	                        if (xhr instanceof XMLHttpRequest) {
	                            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	                        }
	                        // XDomainRequest accepts only text/plain as a content type
	                        xhr.send(encodedData);
	                    } else {
	                        xhr.send();
	                    }
	
	                } catch (e) {
	                    error(xhr);
	                }
	
	                return xhr;
	
	            },
	
	            __getElementByPath: function (targetPath) {
	
	                var parent = document.getElementsByTagName("body")[0]; // start with a body
	                var lastParent = parent;
	
	                if (targetPath.indexOf('#') > -1) {
	                    var targetId = targetPath.split('#')[1];
	
	
	                    if (targetId.indexOf('/') > -1) {
	                        targetId = targetId.split('/')[0];
	                        targetPath = targetPath.substr(targetPath.indexOf("/") + 1, targetPath.length);
	                    }
	                    if (targetId.indexOf('.') > -1) {
	                        targetId = targetId.split('.')[0];
	                    }
	
	                    parent = window.document.getElementById(targetId); // but if there's element with ID, start from the element with ID.
	                }
	
	                targetPath = targetPath.split("/");
	                if (targetPath.length > 0) {
	                    for (var i = 0; i < targetPath.length; i++) {
	
	                        var element = targetPath[i].split("[")
	
	                        if (element[1] == null) {
	                            element[1] = 0; // if there's just one tag in element, it has no index
	                        } else {
	                            element[1] = element[1].split("]")[0] * 1 - 1;
	                        }
	                        if (element[0].indexOf('.') > 0) {
	                            var tempE = element[0].split('.');
	                            element[0] = tempE.shift()
	                            element.push(tempE.join('.'));
	                        }
	
	                        if (parent) {
	                            lastParent = parent;
	                            parent = parent.children[element[1]];
	                        }
	                    }
	                }
	                return parent;
	            },
	
	            _getDomain: function () {
	                if (uShared.domain) return uShared.domain;
	
	                var i = 0,
	                    domain = document.domain,
	                    p = domain.split('.'),
	                    s = '_gd' + (new Date()).getTime();
	                while (i < (p.length - 1) && document.cookie.indexOf(s + '=' + s) == -1) {
	                    domain = p.slice(-1 - (++i)).join('.');
	                    document.cookie = s + "=" + s + ";domain=" + domain + ";";
	                }
	                document.cookie = s + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";";
	                uShared.domain = domain;
	                return domain;
	            },
	
	            // domain
	            _domainChanged: function (url, cUrl) {
	                var urlArr = url.split('/');
	                if (!cUrl) cUrl = uShared._sstorage.get('currentUrl');
	                if (cUrl) {
	                    var currentUrlArr = cUrl.split('/');
	                    uShared._sstorage.set('currentUrl', win.location.href);
	                    if (urlArr[2] != currentUrlArr[2] || urlArr[0] != currentUrlArr[0]) {
	                        return true
	                    }
	                }
	                return false;
	            },
	
	            // set cookie
	
	            _setCookie: function (name, value, expires) {
	
	                if (!win.uDash._globalSettings.uAllowCookies) {
	                    uShared._unsavedCookies[name] = {
	                        "name": name,
	                        "value": value,
	                        "expires": expires
	                    };
	                    return;
	                }
	
	                if (!expires) {
	                    expires = new Date();
	                    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
	                }
	                if (typeof value !== 'string') {
	                    value = JSON.stringify(value);
	                }
	                win.document.cookie = name + '=' + escape(value) + '; domain=' + uShared._getDomain() + '; path=/; expires=' + expires.toGMTString() + ';';
	            },
	            _clearCookie: function (name) {
	                win.document.cookie = name + '=""; domain=' + uShared._getDomain() + '; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
	            },
	            // read cookie
	            _readCookie: function (name) {
	
	                if (win.uDash._globalSettings && !win.uDash._globalSettings.uAllowCookies) {
	                    return uShared._unsavedCookies[name];
	                }
	                var nameEQ = name + "=";
	                var ca = document.cookie.split(';');
	                for (var i = 0; i < ca.length; i++) {
	                    var c = ca[i];
	                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
	                    if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
	                }
	                return null;
	            }
	
	        };
	
	        // localStorage init
	        uShared._lstorage = new uShared._UStorage(win.localStorage);
	
	        // sessionStorage init
	        uShared._sstorage = new uShared._UStorage(win.sessionStorage);
	
	
	
	        return uShared;
	
	    }(window));
	
	    return uShared;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (uShared) {
	
	    // recorder functionality
	    var uRecorder = (function (win) {
	
	        var /* variables */
	            _globalSettings = uShared._extend({}, uShared._defaults),
	
	            // current mouse position
	            _pointerPos = {
	                x: 0,
	                y: 0
	            },
	
	            // remembered document size since last check
	            _memoDocumentSize = {
	                width: 0,
	                height: 0
	            },
	
	
	            _isWindowFocused = true, // flag determining if window is currently focused
	
	            _isFocusedOnTextInput = false, // flag determining if current focus is on input[type=text] or textarea
	            _mutationObserver,
	            _eventsCaptured = {
	
	            },
	            _eventsHandler = {
	
	                // list of event handlers. normal names are attached in loop to window.document, underscored are attached manually
	                _eventHandlers: {
	
	                    doc_click: function (e) {
	                        var scroll = uShared._getScroll();
	
	                        _setPointerPos(e.clientX + scroll.x, e.clientY + scroll.y); // with pointer events, make sure to always explicitly set pointer position for better accuracy
	                        _saveEvent(e.type, e.timeStamp, e.clientX + scroll.x, e.clientY + scroll.y, e.target);
	                    },
	
	                    doc_mouseover: function (e) {
	                        var scroll = uShared._getScroll();
	
	                        _setPointerPos(e.clientX + scroll.x, e.clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.clientX + scroll.x, e.clientY + scroll.y, e.target);
	                    },
	
	                    doc_mousedown: function (e) {
	                        var scroll = uShared._getScroll();
	
	                        _setPointerPos(e.clientX + scroll.x, e.clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.clientX + scroll.x, e.clientY + scroll.y, e.target);
	
	                        dumpManager.send(); // possible session end on click, send events before that
	                    },
	
	
	                    doc_mouseup: function (e) {
	                        var scroll = uShared._getScroll();
	
	                        _setPointerPos(e.clientX + scroll.x, e.clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.clientX + scroll.x, e.clientY + scroll.y, e.target);
	                    },
	
	                    doc_touchstart: function (e) {
	                        var scroll = uShared._getScroll();
	
	                        // set pointer position according to newest changed touch
	                        _setPointerPos(e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y, e.changedTouches[0].target, uShared._propertyNames.shorten(_getTouchesData(e)));
	                    },
	
	                    doc_touchend: function (e) {
	                        var scroll = uShared._getScroll();
	                        _setPointerPos(e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y, e.changedTouches[0].target, uShared._propertyNames.shorten(_getTouchesData(e)));
	                    },
	
	                    doc_touchcancel: function (e) {
	                        var scroll = uShared._getScroll();
	                        _setPointerPos(e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y);
	                        _saveEvent(e.type, e.timeStamp, e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y, e.changedTouches[0].target, uShared._propertyNames.shorten(_getTouchesData(e)));
	                    },
	
	                    doc_keydown: function (e) {
	
	                        // target event by the center of the element for replay reference
	                        var box = e.target.getBoundingClientRect(),
	                            scroll = uShared._getScroll();
	
	                        // don't save key events on text inputs
	                        if (!_isFocusedOnTextInput) {
	                            _saveEvent(e.type, e.timeStamp, Math.ceil(box.left + e.target.offsetWidth / 2 + scroll.x), Math.ceil(box.top + e.target.offsetHeight / 2 + scroll.y), e.target, {
	                                kC: e.keyCode
	                            });
	                        }
	                    },
	
	                    doc_keyup: function (e) {
	
	                        // target event by the center of the element for replay reference
	                        var box = e.target.getBoundingClientRect(),
	                            scroll = uShared._getScroll();
	
	                        // don't save key events on text inputs
	                        if (!_isFocusedOnTextInput) {
	                            _saveEvent(e.type, e.timeStamp, Math.ceil(box.left + e.target.offsetWidth / 2 + scroll.x), Math.ceil(box.top + e.target.offsetHeight / 2 + scroll.y), e.target, {
	                                kC: e.keyCode
	                            });
	                        }
	                    },
	
	
	                    doc_submit: function (e) {
	                        if (_globalSettings.uRecordFormSubmit) {
	                            saveMeta(uShared.META_ACTION, 'Submitted form: ' + _getPath(e.target), false);
	                        }
	                    },
	
	                    doc_focus: function (e) {
	                        if (!e.target || !e.target.getBoundingClientRect) return;
	                        
	                        var box, scroll;
	
	                        if (e.target.tagName && (e.target.tagName.toLowerCase() === 'textarea' || e.target.tagName.toLowerCase() === 'input')) {
	                            _isFocusedOnTextInput = true;
	                        }
	
	                        box = e.target.getBoundingClientRect();
	                        scroll = uShared._getScroll();
	
	                        _saveEvent(e.type, e.timeStamp, Math.ceil(box.left + e.target.offsetWidth / 2 + scroll.x), Math.ceil(box.top + e.target.offsetHeight / 2 + scroll.y), e.target);
	
	                    },
	
	                    doc_blur: function (e) {
	                        if (e.target.tagName && ((e.target.tagName.toLowerCase() === 'input' && ['text', 'email', 'number', 'url', 'tel'].indexOf(e.target.type) > -1) || e.target.tagName.toLowerCase() === 'textarea')) {
	                            _isFocusedOnTextInput = false;
	                        }
	
	                    },
	
	                    doc_change: function (e) {
	                        var box = e.target.getBoundingClientRect(),
	                            scroll = uShared._getScroll(),
	                            data = {},
	                            maskOffset = e.target.getAttribute('udash-mask-offset') || 0,
	                            maskValue = e.target.getAttribute('udash-mask-value') || (maskOffset > 0 ? 'true' : 'auto'),
	                            maskLabel = e.target.getAttribute('udash-mask-label') || (maskOffset > 0 ? 'true' : 'auto'),
	                            ignore = e.target.getAttribute('udash-ignore');
	
	                        if (ignore == 'true') return;
	
	                        if (e.target.type === 'checkbox') {
	                            data.chk = e.target.checked ? 1 : 0;
	                            data.val = data.chk;
	                            if (maskValue == 'auto') maskValue = 'false';
	                        } else {
	
	                            data.val = e.target.value;
	                            if (e.target.tagName.toLowerCase() === 'select') {
	                                data.label = e.target.options[e.target.selectedIndex].innerHTML;
	                                if (data.val == '' && data.val != e.target.options[e.target.selectedIndex].value) {
	                                    data.val = e.target.options[e.target.selectedIndex].value;
	                                }
	                                if (maskLabel == 'true') data.label = _maskInputValue(data.label, maskOffset);
	                                if (maskValue == 'auto') maskValue = 'false';
	                            } else {
	                                if (maskValue == 'auto') maskValue = 'true';
	                            }
	                        }
	
	                        if (maskValue != 'false') {
	                            data.val = _maskInputValue(data.val, maskOffset);
	                        }
	
	                        if (e.target.name) {
	                            data.name = e.target.name;
	                        }else if (e.target.getAttribute('formcontrolname')) {
	                            // this is name used by angular
	                            data.name = e.target.getAttribute('formcontrolname');
	                        }else if (e.target.id && e.target.id.indexOf('tui_')===0){
	                            var l = document.querySelector('label[for="'+e.target.id+'"]');
	                            if (l) {
	                                data.name = l.innerText.trim();
	                            }    
	                        }
	
	                        if (e.target.type) {
	                            data.type = e.target.type;
	                        }
	
	                        _saveEvent(e.type, e.timeStamp, Math.ceil(box.left + e.target.offsetWidth / 2 + scroll.x), Math.ceil(box.top + e.target.offsetHeight / 2 + scroll.y), e.target, data);
	                    },
	
	
	                    // window events
	                    /*
	                    win_unload: function () {
	                        uShared._sstorage.makeBackup(_globalSettings.uProjectName, _globalSettings.uPort, _globalSettings.uProjectApiPass);
	                        dumpManager.send();
	                    },*/
	
	                    // manual dump send
	                    _manualsend: function () {
	
	                        dumpManager.send();
	
	                    },
	
	                    _hashchange: function (e) {
	
	                        var pointerPos = _getPointerPos(),
	                            scroll = uShared._getScroll();
	
	
	                        _autosaveMetaSections();
	
	                        _saveRecord('e', _getTimestamp(e.timeStamp), pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'HashChange', win.location.hash);
	                    }
	                },
	
	                _receiveFrameEvent: function (e) {
	
	                    if (e.data) {
	                        var args = e.data.split('|'),
	                            scroll = uShared._getScroll();
	                        if (args[0] == 'e') {
	                            var frames = document.getElementsByTagName("IFRAME");
	                            var frame = null;
	                            // detect the source for IFRAMEs with same-origin URL
	                            for (var i = 0; i < frames.length; i++) {
	                                if (frames[i].contentWindow == e.source) {
	                                    frame = frames[i];
	                                    break;
	                                }
	                            }
	                            args[4] = _getPath(frame) + '/' + args[4];
	                        }
	
	                        if (args.length == 3) { //a
	                            _saveRecord(args[0], args[1], args[2]);
	                        } else if (frame) {
	                            args[2] *= 1;
	                            args[3] *= 1;
	                            if (args.length == 4) { // p                  
	                                _saveRecord(args[0], _getTimestamp(e.timeStamp), frame.offsetLeft + args[2] + scroll.x, frame.offsetTop + args[3] + scroll.y);
	                            } else if (args.length == 5) {
	                                _saveRecord(args[0], _getTimestamp(e.timeStamp), frame.offsetLeft + args[2] + scroll.x, frame.offsetTop + args[3] + scroll.y, args[4]);
	                            } else if (args.length == 6) {
	                                _saveRecord(args[0], _getTimestamp(e.timeStamp), frame.offsetLeft + args[2] + scroll.x, frame.offsetTop + args[3] + scroll.y, args[4], args[5]);
	                            } else if (args.length == 7) {
	                                _saveRecord(args[0], _getTimestamp(e.timeStamp), frame.offsetLeft + args[2] + scroll.x, frame.offsetTop + args[3] + scroll.y, args[4], args[5], args[6]);
	                            }
	                        }
	                    }
	                },
	
	                // lazy save record handler, fires if enough time passed since last record
	                // used for events that fire far too many times in short periods of time, like mousemove, scroll or resize
	                IntervaledHandler: (function () {
	
	                    var IntervaledHandler = function (options) {
	
	                        this.timeLimit = parseInt(options.time, 10) || 100;
	                        this.lastTimestamp = 0;
	                        this.grabTimeoutName = options.name + 'Grab';
	                        this.save = options.save;
	
	                    };
	
	                    IntervaledHandler.prototype = {
	
	                        handle: function (e, momentInfo, isLastGrab) {
	
	                            isLastGrab = !!isLastGrab;
	
	                            momentInfo = momentInfo || {
	                                scroll: uShared._getScroll()
	                            };
	
	                            var timestamp = Date.now(),
	                                that = this;
	
	                            if (timestamp - this.lastTimestamp > this.timeLimit) {
	
	                                this.lastTimestamp = timestamp;
	                                this.save(e, momentInfo);
	
	                            }
	
	                            // force last save with timeout,
	                            // so even if last change occurs faster than provided time,
	                            // information about it is still valuable and should be recorded
	                            if (!isLastGrab) {
	                                uShared._timeouts.clear(this.grabTimeoutName);
	                                uShared._timeouts.set(this.grabTimeoutName, function () {
	                                    that.handle(e, momentInfo, true);
	                                }, this.timeLimit + 20); // add 20 miliseconds to ensure catch 
	                            }
	                        }
	
	                    };
	
	                    return IntervaledHandler;
	
	                }()),
	
	                attach: function (settings) {
	
	                    var scrollHandler,
	                        resizeHandler,
	                        pointerHandler,
	                        touchmoveHandler;
	
	                    // handle scroll move in 100ms intervals
	                    scrollHandler = new this.IntervaledHandler({
	                        name: 'scroll',
	                        time: 300,
	                        save: function (e, momentInfo) {
	
	                            var scroll = momentInfo.scroll,
	                                pointerPos = _getPointerPos();
	
	                            _saveRecord('e', _getTimestamp(e.timeStamp), pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'Scroll', scroll.x, scroll.y);
	                        }
	                    });
	
	                    // handle pointer move in intervals
	                    pointerHandler = new this.IntervaledHandler({
	                        name: 'pointer',
	                        time: settings.uRecordPointerChange,
	                        save: function (e, momentInfo) {
	
	                            var scroll = momentInfo.scroll;
	
	                            _saveRecord('p', _getTimestamp(e.timeStamp), e.clientX + scroll.x, e.clientY + scroll.y);
	
	                        }
	                    });
	
	                    // handle window resize in intervals
	                    resizeHandler = new this.IntervaledHandler({
	                        name: 'resize',
	                        time: 800,
	                        save: function () {
	                            _saveViewportInfo();
	
	                        }
	                    });
	
	                    touchmoveHandler = new this.IntervaledHandler({
	                        name: 'touchmove',
	                        time: settings.uRecordPointerChange,
	                        save: function (e, momentInfo) {
	
	                            var scroll = momentInfo.scroll;
	
	                            _saveEvent(e.type, e.timeStamp, e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y, e.changedTouches[0].target, uShared._propertyNames.shorten(_getTouchesData(e)));
	                        }
	                    });
	
	
	                    this._eventHandlers.win_scroll = this._eventHandlers.win_scroll || uShared._bindShim(scrollHandler.handle, scrollHandler);
	
	                    this._eventHandlers.win_resize = this._eventHandlers.win_resize || uShared._bindShim(resizeHandler.handle, resizeHandler);
	
	                    this._eventHandlers.win_visibilitychange = function (e) {
	                        uShared._sstorage.makeBackup(_globalSettings.uProjectName, _globalSettings.uPort, _globalSettings.uProjectApiPass);
	                        dumpManager.send();
	                        
	                        _isWindowFocused = document.visibilityState === 'visible';
	                        saveAttribute('Window State', document.visibilityState, false);
	                    }
	
	                    this._eventHandlers.doc_mousemove = this._eventHandlers.doc_mousemove || function (e) {
	
	                        var scroll = uShared._getScroll();
	
	                        _setPointerPos(e.clientX + scroll.x, e.clientY + scroll.y);
	
	                        if (settings.uRecordPointerChange !== false) {
	                            pointerHandler.handle(e, {
	                                scroll: scroll
	                            });
	                        }
	                    };
	
	                    this._eventHandlers.doc_touchmove = this._eventHandlers.doc_touchmove || function (e) {
	
	                        var scroll = uShared._getScroll();
	                        _setPointerPos(e.changedTouches[0].clientX + scroll.x, e.changedTouches[0].clientY + scroll.y);
	
	                        if (settings.uRecordPointerChange !== false) {
	                            touchmoveHandler.handle(e, {
	                                scroll: scroll
	                            });
	                        }
	                    };
	
	
	                    uShared._attachEventHandlers(this._eventHandlers, settings);
	
	                    if (settings.uRecordFrames) {
	                        win.addEventListener("message", this._eventHandlers._receiveFrameEvent, false);
	                    }
	
	                    // if recording hash changes as meta sections is on, register event handler for it
	                    if (settings.uRecordHashChange) {
	                        win.addEventListener('hashchange', this._eventHandlers._hashchange);
	                    }
	
	                    // user defined html element which triggers data sending
	                    if (settings.hasOwnProperty('uSendHook')) {
	                        if (settings.uSendHook.nodeType === 1) {
	                            settings.uSendHook.addEventListener('click', this._eventHandlers._manualsend, false);
	                        } else if (typeof settings.uSendHook === 'string' && win.document.querySelector(settings.uSendHook).nodeType === 1) {
	                            win.document.querySelector(settings.uSendHook).addEventListener('click', this._eventHandlers._manualsend, false);
	                        }
	                    }
	                },
	
	                detach: function (settings) {
	
	                    uShared._detachEventHandlers(this._eventHandlers);
	
	                    // if recording hash changes as meta sections is on, unregister event handler for it
	                    if (settings.uRecordHashChange) {
	                        win.removeEventListener('hashchange', this._eventHandlers._hashchange);
	                    }
	
	                    // remove send hook handler
	                    if (settings.hasOwnProperty('uSendHook')) {
	                        if (settings.uSendHook.nodeType === 1) {
	                            settings.uSendHook.removeEventListener('click', this._eventHandlers._manualsend);
	                        } else if (typeof settings.uSendHook === 'string' && win.document.querySelector(settings.uSendHook).nodeType === 1) {
	                            win.document.querySelector(settings.uSendHook).removeEventListener('click', this._eventHandlers._manualsend);
	                        }
	                    }
	                }
	
	            },
	
	            /* methods */
	
	            // send data and wait for credentials
	            init = function (options) {
	                // initialize console wrapper if it's not ready yet
	                if (typeof uShared._uConsole.log === 'undefined') {
	                    uShared._uConsole.init(options.hasOwnProperty('uShowConsoleMessages') ? options.uShowConsoleMessages : uShared._defaults.uShowConsoleMessages);
	                }
	
	                // missing project name, port or password
	                if (!options.uProjectName || !options.uPort || !options.uProjectApiPass) {
	                    uShared._uConsole.error('uRecorder: Please provide correct uProjectName, uPort and uProjectApiPass');
	                    return false;
	                }
	                var href = decodeURIComponent(window.location.href);
	                if (uShared._sstorage.get('uDebug') || href.indexOf('uDebug@@on') > 0 || href.indexOf('preview@@on') > 0) {
	                    // make sure to remove live mode triggers
	                    if (!uShared._sstorage.get('uDebug')) {
	                        uShared._sstorage.remove('triggers');
	                    }
	                    uShared._sstorage.set('uDebug', true);
	
	                    _globalSettings.uDebug = true;
	
	                    // check if uResponses are added, this will be required for the in-page console to work
	                    if (typeof win.uResponses === "undefined") {
	                        // uResponses object is unavailable, check if it is being loaded
	                        var scripts = document.getElementsByTagName('script'),
	                            responsesLoading = false;
	
	                        for (var i = scripts.length; i--;) {
	                            if (scripts[i].src.indexOf("uResponses") > 0) {
	                                responsesLoading = true;
	                                break;
	                            }
	                        }
	                        if (!responsesLoading) {
	                            // load uResponses 
	                            var s = document.createElement("script");
	                            s.type = "text/javascript";
	                            s.src = "https://" + _globalSettings.cdnDomain + "/sdk/" + options.uPort + "/uResponses.min.js";
	                            win.document.getElementsByTagName("head")[0].appendChild(s);
	                        }
	                    }
	
	                    // don't stop the Recorder 
	                } else if (_globalSettings.uAllowTriggersInNotRecordedSessions || options.uAllowTriggersInNotRecordedSessions || uShared._sstorage.get('uHeatMapData')) {
	
	                } else {
	                    /* custom code to disable default sampling
	                    // sample with returning users favored
	                    if (options.uTrackingMode && options.uTrackingMode=='USERS'){
	                    	if ( Math.random()*100 > options.uSample ){
	                    		if (!uShared._lstorage.get('forced') && !uShared._sstorage.get('browsingPageNum')){
	                    			uShared._sstorage.set('sessionLocked', 'script sample');
	                    			return false;
	                    		}else{
	                    			uShared._lstorage.set('forced',true);
	                    			uDash.saveAttribute('forcedSession', 'true');
	                    		}
	                    	}
	                    }
	                    */
	                    _globalSettings.uForceTracking = options.uForceTracking;
	                    if (uShared._sstorage.get('sessionLocked') && _globalSettings.uForceTracking !== true) {
	                        uShared._uConsole.error('uRecorder: Recording locked in this session, reason: ' + uShared._sstorage.get('sessionLocked'));
	                        return false;
	                    }
	                }
	
	                if (uShared._status === 'notready') {
	
	                    uShared._status = 'setup';
	
	                    uShared._uConsole.log('uRecorder: Welcome to uRecorder! Your version is "' + uShared._version + '". Enjoy developing!');
	
	
	                    // start registering data right away, in case of error it'll be torn down later
	
	                    _setup(options);
	                } else {
	                    uShared._uConsole.log('uRecorder: Already initalized, ignoring init call');
	                }
	            },
	
	            // method called immediatly during initialization - set time of recording and attach events
	            _setup = function (options) {
	
	                win.uDash._globalSettings = _globalSettings;
	                _globalSettings = uShared._extend(_globalSettings, options);
	                /*
	                if (
	                    (win.location.href.indexOf('pomoc')>-1 && (win.location.href.indexOf('salony')>-1 || win.location.href.indexOf('mapa')>-1)) 
	                    || win.location.href.indexOf('udash@@off')>-1
	                ) {
	                    return;
	                }
	                */
	                var uPort = uShared._sstorage.get('uPort') || null;
	                if (uPort) {
	                    if (options.uPort != uPort) {
	                        // different project, need to clear data.
	                        uShared._sstorage.clear({});
	                    }
	                } else {
	                    uShared._sstorage.set('uPort', options.uPort);
	                }
	                var triggersLoaded = false;
	                // set up triggers
	                if (_globalSettings.uTriggersEnabled && uShared._sstorage.get('uTriggersEnabled') !== 'false') {
	                    if (_globalSettings.uTriggersMarking || window.document.documentElement.getAttribute('uib-triggers')) window.document.documentElement.setAttribute('uib-triggers', 'loading');
	                    _setupTriggers();
	                    if (uShared._sstorage.get('triggers') == "loading") {
	                        uShared._failedSetups++;
	                        if (uShared._failedSetups < _globalSettings.uTriggersTimeout / _globalSettings.uTriggersCheckInterval) {
	                            setTimeout(_setup, _globalSettings.uTriggersCheckInterval, options);
	                            return;
	                        }
	                    } else {
	                        triggersLoaded = true;
	                        if (_globalSettings.uTriggersMarking || window.document.documentElement.getAttribute('uib-triggers')) {
	                            setTimeout(function () {
	                                window.document.documentElement.setAttribute('uib-triggers', 'loaded');
	                            }, _globalSettings.uTriggersMarkingDelay);
	                        }
	                    }
	                } else {
	                    if (_globalSettings.uTriggersMarking || window.document.documentElement.getAttribute('uib-triggers')) window.document.documentElement.setAttribute('uib-triggers', 'loaded');
	                    uShared._sstorage.set('triggers', '{}');
	                }
	
	                // is it necessary?
	                if (win.document.querySelector('body')) {} else {
	                    setTimeout(_setup, 100, options);
	                    return;
	                }
	
	                //uShared._sstorage.makeBackup(_globalSettings.uProjectName, _globalSettings.uPort, _globalSettings.uProjectApiPass);
	                // copy user-defined keys into _globalSettings object and build dump url according to them
	
	
	                var wrapper,
	                    currentDate = new Date(),
	                    documentSize = uShared._getDocumentSize();
	
	                _memoDocumentSize = documentSize;
	
	                dumpManager._dumpUrl = _globalSettings.uDumpProtocole + '//' + ((_globalSettings.uPort === '_noport') ? '' : _globalSettings.uPort + '.') + _globalSettings.uDumpDomain + '/' + _globalSettings.uDumpMethod;
	                dumpManager._emptySendLimit = _globalSettings.uEmptySendLimit;
	                dumpManager._keepConnection = _globalSettings.uKeepConnection;
	
	                // if user explicitly set page wrapper selector, check it
	                if (_globalSettings.uWrapperSelector && (wrapper = win.document.querySelector(_globalSettings.uWrapperSelector)) && wrapper.nodeType === 1) {
	                    uShared._wrapFinder.setWrapper(wrapper);
	                } else { // otherwise, find it
	                    uShared._wrapFinder.find();
	                }
	
	                // reveal udashSessionToken
	
	                win.udashSessionToken = uShared._sstorage.get('logDumpToken') || '';
	                // check if user starts new browsing session
	
	                if (!uShared._sstorage.get('timeOffset') || win.udashSessionToken === '') {
	                    // set current time offset
	                    var d = Date.now();
	                    if (typeof d === "object") {
	                        d = d.getTime();
	                    } else if (typeof d !== "number") {
	                        d = new Date().getTime();
	                    }
	                    uShared._sstorage.set('timeOffset', d);
	
	                    var uid = uShared._readCookie('uDashUserID') || uShared._lstorage.get('userID');
	                    // check if user is visiting page another time
	                    if (!uid && uid!=='') {
	                        uid = _generateUserStorageData(); // if not, initialize him	
	                    } else { // if he is, increase visits counter
	                        var visit = uShared._lstorage.get('userVisit') * 1 + 1;
	                        uShared._lstorage.set('userVisit',
	                            visit
	                        );
	                        if (_globalSettings.uCrossSiteSessionsEnabled) {
	                            uShared._setCookie('uDashUserID', uid); // to extend the expiration date
	                            uShared._setCookie('uDashUserVisit', visit);
	                        }
	                    }
	
	                    // set approperiate headers and events
	                    _saveRecord('h', 'o', _globalSettings.uPort, _globalSettings.uProjectName, _globalSettings.uProjectApiPass);
	                    saveAttribute('fsc', [
								['R', (win.screen.width || 'unknown') + 'x' + (win.screen.height || 'unknkown')].join('='),
								['L', (win.navigator.language || win.navigator.userLanguage || '').toLowerCase().substr(0, 2) || 'unknown'].join('=')
							].join('&'));
	                    saveAttribute('language', win.navigator.language || win.navigator.userLanguage || 'unknown');
	                    saveAttribute('screenWidth', win.screen.width || 'unknown');
	                    saveAttribute('screenHeight', win.screen.height || 'unknown');
	                    saveAttribute('userAgentString', win.navigator.userAgent || 'unknown');
	                    saveAttribute('userID', uid);
	                    saveAttribute('userVisit', uShared._lstorage.get('userVisit'));
	                    if (uShared._lstorage.get('firstVisit')) saveAttribute('firstVisit', uShared._lstorage.get('firstVisit'));
	                    saveAttribute('version', uShared._version);
	                    saveAttribute('timezoneOffset', currentDate.getTimezoneOffset());
	                    saveAttribute('referrer', win.document.referrer || 'none');
	                    saveAttribute('entryUrl', uShared._prepareUrl(win.location.href.split('uParams')[0]));
	                    saveAttribute('hostname', win.location.hostname);
	                    if ('ontouchstart' in win.document) {
	                        saveAttribute('interface', 'touch');
	                    } else {
	                        saveAttribute('interface', 'mouse');
	                    }
	
	                    // custom code
	                    // end of custom code
	
	                    _saveRecord('e', _getTimestamp(), 0, 0, '_uJS', 'LocationChange', win.location.href);
	                    saveMeta('URL', win.location.href);
	
	                    // cookies at the beginning of a session
	                    setTimeout(_recordCookies, 500);
	
	                    _checkOpenedWithFocus();
	
	                    _autosaveMetaSections();
	
	                    _saveViewportInfo();
	
	                    dumpManager._wasVisitSent = false;
	
	                    //uShared._sstorage.set('browsingPageNum', 1);	
	
	                    uShared._sstorage.set('currentUrl', win.location.href);
	
	                } else { // if user continues browsing session, save size of newly entered document
	
	                    dumpManager._locationChange(); // check if there are leftovers from unfinished data sending
	
	                    if (uShared._domainChanged(win.location.href)) {
	                        setTimeout(_recordCookies, 500);
	                        saveAttribute('hostname', win.location.hostname);
	                    }
	
	                    _saveRecord('e', _getTimestamp(), 0, 0, '_uJS', 'LocationChange', win.location.href);
	                    saveMeta('URL', win.location.href);
	                    _checkOpenedWithFocus();
	                    _autosaveMetaSections();
	                    _saveViewportInfo();
	                    dumpManager._wasVisitSent = true;
	                    dumpManager.send();
	                }
	
	                if (!triggersLoaded) {
	                    if (_globalSettings.uTriggersMarking || window.document.documentElement.getAttribute('uib-triggers')) {
	                        window.document.documentElement.setAttribute('uib-triggers', 'failed');
	                    }
	                    saveMeta('alert', 'Triggers loading failed');
	                }
	
	                _eventsHandler.attach(_globalSettings);
	
	                if (_globalSettings.uRecordPageChanges) {
	                    try {
	                        _mutationObserver = new MutationObserver(function (mutations) {
	                            mutations.forEach(function (mutation) {
	                                var maskTagContentSelectors = _prepareMaskTagSelectors(_globalSettings.maskTagContentSelectors);
	                                // unused:
	                                //var maskTagAttributeSelectors=_prepareMaskTagSelectors (_globalSettings.maskTagAttributeSelectors);
	                                if (mutation.target && mutation.target.closest('#uConsole')) {
	                                    return;
	                                }
	                                if (mutation.type) {
	                                    if (mutation.type === 'childList') {
	                                        if (mutation.removedNodes.length > 0) {
	                                            var html = mutation.target.innerHTML.trim();
	                                            html = _maskTagContent(html, maskTagContentSelectors);
	                                            _saveMutation('mutate', mutation.target, {
	                                                type: 'replaceChildren',
	                                                innerHTML: html
	                                            });
	                                        } else {
	                                            if (mutation.addedNodes.length > 0) {
	                                                for (var i = 0; i < mutation.addedNodes.length; i++) {
	                                                    var newEl = mutation.addedNodes[i];
	                                                    if (!newEl.outerHTML && newEl.parentElement) {
	                                                        newEl = newEl.parentElement;
	                                                    }
	                                                    var html = newEl.outerHTML.trim();
	                                                    html = _maskTagContent(html, maskTagContentSelectors);
	
	                                                    if (newEl.parentElement) {
	                                                        var index = Array.prototype.indexOf.call(newEl.parentElement.children, newEl);
	                                                        _saveMutation('mutate', newEl.parentElement, {
	                                                            type: 'addChild',
	                                                            outerHTML: html,
	                                                            index: index
	                                                        });
	                                                    }
	
	                                                }
	                                            }
	                                        }
	                                    } else if (mutation.type == 'attributes') {
	                                        var attribute = mutation.target.attributes[mutation.attributeName];
	                                        var value = '';
	                                        if (attribute) {
	                                            value = attribute.value;
	                                        }
	                                        _saveMutation('mutate', mutation.target, {
	                                            type: mutation.type,
	                                            attributeName: mutation.attributeName,
	                                            attributeValue: value
	                                        });
	                                    } else if (mutation.type == 'characterData') {
	                                        var html = mutation.target.parentNode.outerHTML;
	                                        var template = document.createElement('template');
	                                        template.innerHTML = _maskTagContent(html, maskTagContentSelectors);
	                                        var text = template.content.firstChild.innerText.trim();
	                                        template = null;
	                                        _saveMutation('mutate', mutation.target.parentNode, {
	                                            type: mutation.type,
	                                            innerText: text
	                                        });
	                                    }
	                                }
	                                //console.log(mutation);
	                            });
	                        }.bind(this));
	                        _mutationObserver.observe(document.documentElement, {
	                            attributes: true,
	                            characterData: true,
	                            childList: true,
	                            subtree: true
	                        });
	                        // Takes all changes which haven’t been fired so far.
	                        _mutationObserver.takeRecords();
	                    } catch (e) {
	
	                    }
	                }
	
	                // attach timeouts for sending dump and watching document size
	                dumpManager._setSendTimeout();
	                _setDocumentSizeUpdateTimeout();
	
	                // augment XMLHttpRequest object to watch ajax calls
	                /*
						(function(XHRProtoOpen) {
							
							XMLHttpRequest.prototype._oldOpen = XMLHttpRequest.prototype.open;
							XMLHttpRequest.prototype.open = function() {
	
								var	args = Array.prototype.slice.call(arguments),
									url = args[1];
	
								if(!this.hasOwnProperty('_uibRequest')) { // do not watch calls from uDash
	
									this.addEventListener('readystatechange', function() {
					
										var response;
										
										if(_globalSettings.uRecordAjax && this.readyState === 4) {
											response = this.responseText || this.responseHTML || this.responseXML || '';
											_saveRecord('s', _globalSettings.uAjaxCacheFlag, url, '<![CDATA[' + response.replace(/\n/g, '\r') + ']]>');
										}
									}, false);
	
								}
	
								return XHRProtoOpen.apply(this, arguments);
							};
						}(XMLHttpRequest.prototype.open));
	                    */
	
	
	                uShared._status = 'ready';
	
	                if (_globalSettings.hasOwnProperty('onReady') && typeof _globalSettings.onReady === 'function') {
	                    _globalSettings.onReady.call(win.uDash);
	                }
	
	                if (uShared._sstorage.get('sessionLocked')) {
	                    if (_globalSettings.uForceTracking !== true) {
	                        uShared._status = 'notready';
	                    } else {
	                        win.sessionStorage.removeItem('uDash.sessionLocked');
	                    }
	                }
	
	                // dump init
	                if (uShared._status === 'ready') { // if onReady callback did not torn uDash down for some reason
	                    if (!dumpManager._isConnected()) {
	                        dumpManager._connect();
	                    } else {
	                        _setConnected();
	                    }
	                }
	
	            },
	
	            // set recorder status to ready and fire onReady callback
	            _setConnected = function () {
	
	                uShared._status = 'connected';
	
	                if (_globalSettings.hasOwnProperty('onConnected') && typeof _globalSettings.onConnected === 'function') {
	                    _globalSettings.onConnected.call(win.uDash);
	                }
	
	                if (_globalSettings.hasOwnProperty('onDumpSend') && typeof _globalSettings.onDumpSend === 'function') {
	                    dumpManager._onSend = _globalSettings.onDumpSend;
	                }
	
	                uShared._sstorage.makeBackup(_globalSettings.uProjectName, _globalSettings.uPort, _globalSettings.uProjectApiPass);
	                dumpManager.send();
	            },
	
	            // tear down whole recorder
	            tearDown = function () {
	
	                if (uShared._sstorage.get('uDebug')) {
	                    return; // let uDash run in debug;
	                }
	
	                if (_globalSettings.uAllowTriggersInNotRecordedSessions) {
	                    return; // let uDash run in triggers
	                }
	
	                if (uShared._sstorage.get('uHeatMapData')) {
	                    return; // let uDash run in triggers
	                }
	
	                var status = uShared.getStatus();
	
	                if (status !== 'teardown' && status !== 'notready') {
	
	                    uShared._status = 'teardown';
	
	                    dumpManager._disconnect();
	
	                    _eventsHandler.detach(_globalSettings);
	
	                    // clear all pending timeouts
	                    uShared._timeouts.clearAll();
	
	                    // de-augment ajax
	                    if (typeof XMLHttpRequest.prototype._oldOpen === 'function') {
	                        XMLHttpRequest.prototype.open = XMLHttpRequest.prototype._oldOpen;
	                    }
	
	                    // flush session storage data except the information about locked session
	                    uShared._sstorage.clear({
	                        except: ['sessionLocked']
	                    });
	
	                    _setPointerPos(-1000, -1000);
	
	                    uShared._status = 'notready';
	
	                    // user-defined callback fired after teardown happened
	                    if (_globalSettings.hasOwnProperty('onTeardown') && typeof _globalSettings.onTeardown === 'function') {
	                        _globalSettings.onTeardown.call(win.uDash);
	                    }
	
	                    uShared._uConsole.log('uRecorder: uRecorder torn down');
	                }
	
	            },
	
	            trackShadowRoot = function (el) {
	                if (el && el.shadowRoot) {
	                    el.setAttribute('udash-ignore', 'true');
	                    uShared._attachEventHandlers(_eventsHandler._eventHandlers, _globalSettings, el.shadowRoot);
	                }
	            },
	
	            _prepareMaskTagSelectors = function (selectors) {
	                var preparedSelectors = [];
	                for (var i = 0; i < selectors.length; i++) {
	
	                    var selector = selectors[i];
	                    var fc = selector.substr(0, 1);
	                    if (fc === '.') {
	                        selector = selector.split(' ')[0].split('#')[0].substr(1).split('.').join(' ');
	                        selector = 'class="' + selector + '"';
	                    } else if (fc === '[') {
	                        selector = selector.split(']')[0].substr(1);
	                    } else if (fc === '#') {
	                        selector = selector.split('.')[0].split(' ')[0];
	                        selector = 'id="' + selector.substr(1) + '"';
	                    }
	
	                    selector = '*' + selector + '*';
	                    preparedSelectors.push(selector);
	                }
	                if (preparedSelectors.length == 0) {
	                    preparedSelectors.push('');
	                }
	                return preparedSelectors;
	            },
	
	            _maskTagContent = function (html, selectors) {
	                var maskForSelector = function (html, selector) {
	                    var re = new RegExp('(<' + selector + '\\b[^>]*>)([^<>]*)(<\/\\b[^>]*>)', "g");
	                    html = html.replace(re, function (a, prefix, mask, sufix) {
	                        mask = mask.replace(/[a-zęóąśłżźćń]/g, 'x');
	                        mask = mask.replace(/[A-ZĘÓĄŚŁŻŹĆŃ]/g, 'X');
	                        mask = mask.replace(/[0-9]/g, '9');
	                        return prefix + mask + sufix;
	                    });
	                    return html;
	                }
	                for (var i = 0; i < selectors.length; i++) {
	                    html = maskForSelector(html, selectors[i]);
	                }
	                return html
	            },
	
	            _maskInputValue = function (text, offset) {
	                if (!text || !text.substr) return;
	                if (offset == undefined) offset = 0;
	                var pref = text.substr(0, offset);
	                var mask = text.substr(offset, text.length);
	                mask = mask.replace(/[a-zęóąśłżźćń]/g, 'x');
	                mask = mask.replace(/[A-ZĘÓĄŚŁŻŹĆŃ]/g, 'X');
	                mask = mask.replace(/[0-9]/g, '9');
	                return pref + mask;
	            },
	
	            // check if window was opened with focus on it (as opposed to for instance in a new tab without switch)
	            // if hasFocus is unsupported, assume focus
	            _checkOpenedWithFocus = function () {
	                var focus = document.visibilityState ? document.visibilityState === 'visible' : true;
	                saveAttribute('Window State', focus, false);
	                _isWindowFocused = focus;
	            },
	
	            // saves url as section according to _globalSettings
	            _autosaveMetaSections = function () {
	
	                var toSave = uShared._getMetaSectionAutosaveName(_globalSettings);
	
	                if (toSave) {
	
	                    var section = uShared._prepareUrl(decodeURIComponent(toSave));
	                    //var lastSection = uShared._sstorage.get('lastSection');
	                    // custom code to modify default based on url
	                    // end of custom code
	                    saveMeta(uShared.META_SECTION, section, false);
	
	                }
	
	            },
	
	            // setter for pointer position
	            _setPointerPos = function (x, y) {
	                _pointerPos.x = x;
	                _pointerPos.y = y;
	            },
	
	            // getter for pointer position
	            _getPointerPos = function () {
	                return {
	                    x: _pointerPos.x,
	                    y: _pointerPos.y
	                };
	            },
	
	            _getTouchesData = function (e) {
	
	                var data = {
	                        touches: [],
	                        targetTouches: [],
	                        changedTouches: []
	                    },
	                    extract = ['clientX', 'clientY', 'screenX', 'screenY', 'pageX', 'pageY', 'identifier'],
	                    touchName,
	                    i,
	                    j;
	
	                for (touchName in data) {
	                    if (data.hasOwnProperty(touchName) && e.hasOwnProperty(touchName)) {
	                        for (i = 0; i < e[touchName].length; i++) {
	                            data[touchName][i] = {};
	                            for (j = 0; j < extract.length; j++) {
	                                if (e[touchName][i].hasOwnProperty(extract[j])) {
	                                    data[touchName][i][extract[j]] = e[touchName][i][extract[j]];
	                                }
	                            }
	                            data[touchName][i].checkTag = e[touchName][i].target.tagName.toLowerCase();
	                        }
	                    }
	                }
	
	                return data;
	
	            },
	
	            _saveViewportInfo = function () {
	
	                var windowSize = uShared._getWindowSize(),
	                    documentSize = uShared._getDocumentSize(),
	                    timestamp = _getTimestamp(),
	                    pointerPos = _getPointerPos(),
	                    scroll = uShared._getScroll();
	
	                _saveRecord('e', timestamp, pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'Viewport', windowSize.width, windowSize.height); // user's viewport width & height
	                _saveRecord('e', timestamp, pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'Resize', documentSize.width, documentSize.height); // document width & height
	                _saveRecord('e', timestamp, pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'Scale', uShared._getDocumentScale()); // document scale
	                _saveRecord('e', timestamp, pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'WrapperOffset', uShared._wrapFinder.getWrapperOffset()); // site's main wrapper left offset
	            },
	
	            // dump manager
	            // handles connecting to dump server, saving and getting records
	            // and watching package or time limit excess
	            dumpManager = {
	
	                _currentDumpName: 'dump',
	
	                _currentXhr: null,
	
	                _dumpUrl: '',
	
	                _emptySendCount: 0,
	
	                _emptySendLimit: Infinity,
	
	                _wasVisitSent: false,
	
	                _handleConnection: function (response) {
	
	                    var status = response.split('<status>')[1].split('</status>')[0];
	
	                    switch (status) {
	
	                        case 'ok':
	
	                            if (response.indexOf('token') > -1) { // token retrieved, save it
	                                var token = response.split('<token>')[1].split('</token>')[0];
	                                uShared._sstorage.set('logDumpToken', token);
	                                uShared._uConsole.log('uRecorder: Recorder connected, token:', token);
	                                saveAttribute('sessionToken', token);
	                                win.udashSessionToken = token;
	                                _setConnected();
	                            } else { // no token retrieved, probably incorrect login/password
	                                uShared._uConsole.error('uRecorder: No token recieved');
	                                tearDown();
	                            }
	
	                            break;
	
	                        case 'error project':
	
	                            //uShared._uConsole.error('uRecorder: Login error, please check your project name and password');
	                            tearDown();
	
	                            break;
	
	                        case 'out of limits':
	
	                            //uShared._uConsole.error('uRecorder: Server capacity exceeded');
	                            uShared._sstorage.set('sessionLocked', 'server capacity exceeded');
	                            tearDown();
	
	                            break;
	
	                        default:
	
	                            //uShared._uConsole.error('uRecorder: Unknown server response');
	                            tearDown();
	
	                            break;
	                    }
	                },
	
	                _onSend: function () {},
	
	                _locationChange: function () {
	                    var tempDumpContent = uShared._sstorage.get('tempDump') || '';
	                    if (tempDumpContent.length > 0) {
	                        uShared._sstorage.set('tempDump', '');
	                        uShared._sstorage.set('dump', tempDumpContent);
	                    }
	                },
	
	                _isConnected: function () {
	                    var token = uShared._sstorage.get('logDumpToken');
	
	                    return (token !== null && token.length >= 10);
	                },
	
	                _connect: function () {
	
	                    if (!_globalSettings.uAllowTracking) {
	                        return;
	                    }
	
	                    var that = this,
	                        data = {
	                            start: 1,
	                            project: _globalSettings.uProjectName,
	                            force: _globalSettings.uForceTracking === true ? 1 : 0
	                        }
	                    /* store group assignments
	                    if (_globalSettings.triggers){
	                        data.userID =  uShared._lstorage.get('userID');
	                        data.in = JSON.stringify(_globalSettings.triggers.in);
	                        data.out = JSON.stringify(_globalSettings.triggers.out);
	                    }*/
	                    this._currentXhr = uShared._ajax({
	                        url: this._dumpUrl,
	                        data: data,
	                        success: function (response) {
	
	                            that._currentXhr = null;
	
	                            that._handleConnection(response);
	
	
	                        },
	                        error: function () {
	                            that._currentXhr = null;
	                            uShared._uConsole.error('uRecorder: Connection to server failed');
	                            tearDown();
	                        }
	                    });
	
	                },
	
	                _disconnect: function () {
	
	                    if (this._currentXhr !== null) {
	                        this._currentXhr.abort();
	                        this._currentXhr = null;
	                    }
	
	                },
	                _revertDump: function () {
	                    var tempDumpContent = uShared._sstorage.get('tempDump') || '',
	                        dumpContent = uShared._sstorage.get('dump') || '';
	
	                    uShared._sstorage.set('dump', dumpContent + tempDumpContent);
	                    this._currentDumpName = 'dump';
	                },
	                _setTempMode: function (yes) {
	                    if (yes) {
	                        this._currentDumpName = 'tempDump';
	                    } else {
	                        this._currentDumpName = 'dump';
	                        var tempDumpContent = uShared._sstorage.get('tempDump') || '';
	                        uShared._sstorage.set('tempDump', '');
	                        uShared._sstorage.set('dump', tempDumpContent);
	                    }
	
	                },
	
	                _getDumpArray: function () {
	
	                    var dump = uShared._sstorage.get(this._currentDumpName);
	
	                    if (dump) {
	                        return dump.split(uShared._recordsSeparator);
	                    } else {
	                        return [];
	                    }
	
	                },
	
	                _setDumpByArray: function (array) {
	                    //uShared._timeouts.set('backupDumpTimeout', function() {
	                    uShared._sstorage.set(this._currentDumpName, array.join(uShared._recordsSeparator));
	                    //}.bind(this), 1 * 1000);
	                },
	
	                _newRecord: function (parts) {
	
	                    var currentDump = this._getDumpArray();
	
	                    currentDump.push(parts.join('|'));
	                    this._setDumpByArray(currentDump);
	
	                    if (currentDump.length + 1 >= _globalSettings.uPackageLimit) { // records limit for dump reached, send package
	                        this.send();
	                    }
	                },
	
	                // sending dump in time intervals
	                _setSendTimeout: function () {
	                    var that = this;
	                    if (_globalSettings.uSendTimeout !== false && !isNaN(parseInt(_globalSettings.uSendTimeout, 10))) {
	                        uShared._timeouts.set('dumpTimeout', function () {
	                            if (_isWindowFocused) {
	                                that.send();
	                            }
	                            that._setSendTimeout();
	                        }, parseInt(_globalSettings.uSendTimeout, 10) * 1000);
	                    }
	                },
	
	                _deleteLastRecordIf: function (conditionFunc) {
	                    var records = this._getDumpArray();
	                    if (conditionFunc(records.pop())) {
	                        this._setDumpByArray(records);
	                    }
	                },
	
	                send: function () {
	                    var logDumpToken = win.udashSessionToken || uShared._sstorage.get('logDumpToken') || '',
	                        that = this,
	                        data,
	                        isCompressed = 0,
	                        isEmpty;
	
	                    if ( // send only if
	                        uShared._status !== 'connected' || // uDash is connected to a server
	                        this._currentDumpName !== 'dump' || // dump being send is regular, not a temp
	                        this._currentXhr !== null // there is no pending request right now
	                    ) {
	                        return false;
	                    } else {
	                        isEmpty = (this._getDumpArray().length === 0);
	
	                        if (isEmpty) {
	                            this._emptySendCount++;
	                            if (this._emptySendCount >= this._emptySendLimit) {
	                                //uShared._uConsole.warn('uRecorder: empty send limit reached, tearing session down');
	                                return tearDown();
	                            }
	                        } else {
	                            this._emptySendCount = 0;
	                        }
	                        if (!isEmpty || this._keepConnection) {
	                            this._currentXhr = new XMLHttpRequest(); // mock xhr object in order to lock sending and not fall into recursion after saving meta below (constant excess of records limit)
	
	                            data = this._getDumpArray().join(uShared._recordsSeparator); // reload data after above meta save
	
	                            this._setTempMode(true);
	                            this._currentXhr = uShared._ajax({
	                                url: this._dumpUrl + '?' + 'project=' + _globalSettings.uProjectName + '&token=' + logDumpToken,
	                                data: {
	                                    data: data,
	                                    append: 1,
	                                    compr: isCompressed
	                                },
	                                error: function () {
	                                    if (uShared._failedRequests > uShared._failedRequestRetry) {
	                                        uShared._uConsole.error('uRecorder: Error while sending log');
	                                        tearDown();
	                                    } else {
	                                        that._revertDump()
	                                        that._currentXhr = null;
	                                    }
	                                },
	                                success: function (response) {
	                                    // if request succeeded and returned status is ok, flush the dump and call onDumpSend callback
	                                    if (response.split('<status>')[1].split('</status>')[0] === 'ok') {
	                                        that._wasVisitSent = true;
	                                        that._setTempMode(false);
	
	                                        // clear timeout with some delay to prevent shooting dumps at server
	                                        uShared._timeouts.set('clearDumpXhr', function () {
	                                            that._currentXhr = null;
	                                        }, 2000);
	
	                                        if (typeof that._onSend === 'function') {
	                                            that._onSend.call(win.uDash, response);
	                                        }
	                                        var pushData = response.split('<json>');
	                                        if (pushData.length > 1) {
	                                            pushData = JSON.parse(pushData[1].split('</json>')[0]);
	                                            var l = pushData.length;
	                                            saveMeta('Push Received', l);
	                                            for (var i = 0; i < l; i++) {
	                                                var datapoint = pushData[i].split('|');
	                                                if (datapoint[0] === 'a') {
	                                                    saveAttribute(datapoint[1], datapoint[2]);
	                                                } else if (datapoint[0] === 'm') {
	                                                    saveMeta(datapoint[1], datapoint[2]);
	                                                }
	                                            }
	                                        }
	                                    } else {
	                                        uShared._uConsole.error('uRecorder: Session Expired');
	                                        // server returned error status for project, so we might as well turn everything down now
	                                        tearDown();
	                                    }
	                                }
	                            });
	                        }
	                    }
	                }
	
	            },
	
	
	            // watch for document size change
	            _setDocumentSizeUpdateTimeout = function () {
	                uShared._timeouts.set('sizeUpdate', function () {
	                    // grab current size
	                    var documentSize = uShared._getDocumentSize(),
	                        pointerPos = _getPointerPos(),
	                        scroll = uShared._getScroll();
	
	                    // if there was a change in size, save record and update memoized size
	                    if (_memoDocumentSize.width !== documentSize.width || _memoDocumentSize.height !== documentSize.height) {
	                        _saveRecord('e', _getTimestamp(), pointerPos.x + scroll.x, pointerPos.y + scroll.y, '_uJS', 'Resize', documentSize.width, documentSize.height);
	                        _memoDocumentSize = documentSize;
	                    }
	                    _setDocumentSizeUpdateTimeout();
	                }, 500);
	            },
	
	
	            // if user id and visits are not set, generate them
	            _generateUserStorageData = function () {
	                var id = new Date().valueOf() + "/" + Math.round(Math.random() * 1000000000);
	
	                if (_globalSettings.uCrossSiteSessionsEnabled) {
	                    uShared._setCookie('uDashUserID', id);
	                    uShared._setCookie('uDashUserVisit', 1);
	                }
	                uShared._lstorage.set('userID', id);
	                uShared._lstorage.set('userVisit', 1);
	
	                var d = new Date();
	                var dArr = d.toString().split(' ');
	                var t = dArr[4].substr(0, 5);
	                var m = d.getMonth() + 1;
	                if (m < 10) m = '0' + m;
	                var date = dArr[3] + '-' + m + '-' + dArr[2] + ' ' + t;
	
	                uShared._lstorage.set('firstVisit', date);
	                
	                return id;
	            },
	
	            // unused date formatting helper
	            /*_formatDate = function(date) {
	            	date = date || new Date();
	
	            	var	days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            		months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            		gmt = function() {
	            			var	gmt = parseInt(date.getTimezoneOffset(), 10) / -60,
	            				str = '';
	
	            			str += gmt;
	
	            			if((gmt + '').length  === 1) {
	            				str = '0' + str + '00';
	            			} else {
	            				str = str + '00';
	            			}
	            			str = (gmt > 0) ? '+' + str : '-' + str;
	            			return str;
	            		},
	            		appendZero = function(str) {
	            			if((str + '').length === 1) {
	            				return '0' + str;
	            			}
	            			return str;
	            		};
	
	
	            	return days[date.getDay()] + ' ' + months[date.getMonth()] + ' ' + date.getDate() + ' ' + appendZero(date.getHours()) + ':' + appendZero(date.getMinutes()) + ':' + appendZero(date.getSeconds()) + ' GMT' + gmt() + ' ' + date.getFullYear();
	
	            },*/
	
	            // helper for checking if string can be used in record
	            _isValidString = function (string) {
	                return (string !=='' && string !== null && typeof string !== 'undefined' && string === string /* NaN */ );
	            },
	
	            // 'e' type mutation save
	            _saveMutation = function (type, target, info) {
	                if (_eventsCaptured[_globalSettings.uRecordPageChangesAfterEvent]) {
	                    _saveRecord('e', _getTimestamp(), -1, -1, _getPath(target), type, JSON.stringify(info));
	                }
	            },
	            // 'e' type event save
	            _saveEvent = function (type, timestamp, x, y, target, info) {
	                _eventsCaptured[type] = 1;
	                if (_globalSettings.uRecordInteractiveEvents && !target.getAttribute('udash-ignore')) {
	                    _saveRecord('e', _getTimestamp(timestamp), x, y, _getPath(target), type, JSON.stringify(info));
	                }
	            },
	
	
	            // 'm' type event save
	            saveMeta = function (label, value, delay) {
	
	                if (value === null || typeof value === 'undefined') {
	                    return;
	                }
	                if (value.replace) {
	                    value = value.replace(/\s/g, " ").trim();
	                    if (value == '') return;
	                }
	                var pointerPos = _getPointerPos(),
	                    scroll = uShared._getScroll(),
	                    beforeSave = function (label, value) { // path, time to action, time in section
	                        if (label === uShared.META_ACTION) {
	                            saveMeta('Time to ' + value, Math.round(_getTimestamp() / 1000), false);
	                        } else if (label === uShared.META_SECTION) {
	                            var lastSection = uShared._sstorage.get('lastSection') || '';
	                            uShared._sstorage.set('beforeLastSection', lastSection);
	                            uShared._sstorage.set('lastSection', value);
	                        }
	                    };
	
	                if (typeof delay === 'undefined') { // delay saving metas by default
	                    delay = true;
	                }
	
	                if (!_isValidString(label)) {
	                    uShared._uConsole.error('uRecorder: Saving meta event failed, please provide label');
	                    return;
	                }
	
	                if (delay) { // delay saving meta a bit to ensure that event triggering it is recorded before meta 
	                    uShared._timeouts.set('saveMeta', function () {
	                        beforeSave(label, value);
	                        _saveRecord('m', _getTimestamp(), pointerPos.x + scroll.x, pointerPos.y + scroll.y, label, value);
	                    }, 0);
	                } else {
	                    beforeSave(label, value);
	                    _saveRecord('m', _getTimestamp(), pointerPos.x + scroll.x, pointerPos.y + scroll.y, label, value);
	                }
	
	                if (label === uShared.META_SECTION) {
	                    uShared._uHeatMapSection = value;
	                    //TODO - heatmap should not be referenced here directly
	                    if (win.uHeatMap)
	                        win.uHeatMap.saveMeta(uShared.META_SECTION, value);
	                }
	            },
	
	            // 'a' type event save
	            saveAttribute = function (attrib, value) {
	                if (!_isValidString(attrib) || !_isValidString(value)) {
	                    uShared._uConsole.error('uRecorder: Saving attribute failed, please provide label and value');
	                    return;
	                }
	                _saveRecord('a', attrib, value);
	            },
	
	            // generic record save
	            // call gets passed to formatting with timestamp and mouse coordinates
	            _saveRecord = function () {
	
	                var args = Array.prototype.slice.call(arguments),
	                    type = args.shift(),
	                    parts = [type],
	                    withoutTimeAndPointer = ['a', 'h', 's'],
	                    i,
	                    timestamp;
	
	                // check against triggers conditions
	                if (_globalSettings.uTriggersEnabled) {
	
	                    if (type == 'e' || type == 'm') {
	                        if (args[5]) {
	                            _checkAgainstConditions(type, args[3], args[4], args[5]);
	                        } else {
	                            _checkAgainstConditions(type, args[3], args[4]);
	                        }
	                    } else if (type == 'a') {
	                        _checkAgainstConditions(type, args[0], args[1]);
	                    }
	                }
	
	                // custom code
	
	                if (withoutTimeAndPointer.indexOf(type) === -1) { // add time and pointer coordinates for records that are not of type specified in withoutTimeAndPointer
	                    timestamp = args.shift();
	                    if (timestamp > 100000000 || timestamp < 0) { // for buggy e.timeStamp implementations (Firefox)
	                        timestamp = _getTimestamp();
	                    }
	                    parts = parts.concat([timestamp, args.shift(), args.shift()]);
	                }
	
	                // remove undefined arguments
	                for (i = 0; i < args.length; i++) {
	                    if (typeof args[i] === 'undefined' || args[i] === null || args[i] === '') {
	                        args.splice(i, 1);
	                    }
	                }
	
	                parts = parts.concat(args);
	
	                if (_globalSettings.uDebug) {
	                    if (type != 'p') {
	                        if (type === 'a') {
	                            if (typeof uResponses !== 'undefined' && uResponses.helpers.traceEvent) {
	                                uResponses.helpers.traceEvent(type, parts[1], parts[2]);
	                            }
	                            if (_globalSettings.uShowEventsTraceInConsole) uShared._uConsole.log("(A):", parts[1] + "=" + parts[2]);
	                        } else if (type === 'm') {
	                            if (parts[5] != undefined) {
	                                if (typeof uResponses !== 'undefined' && uResponses.helpers.traceEvent) {
	                                    uResponses.helpers.traceEvent(type, parts[4], parts[5]);
	                                }
	                                if (_globalSettings.uShowEventsTraceInConsole) uShared._uConsole.log("(M):", parts[4] + "=" + parts[5]);
	                            }
	                        } else {
	                            parts[1] = Math.round(parts[1]);
	                            parts[2] = Math.round(parts[2]);
	                            if (parts[4] != '_uJS') {
	                                var args = undefined;
	                                if (parts[5] == 'change' && parts[6]) {
	                                    /*if (parts[4].indexOf('.')){
	                                        parts[4] = parts[4].split('.')[0];
	                                    };*/
	                                    args = parts[6];
	                                } else {}
	                                if (typeof uResponses != 'undefined' && uResponses.helpers.traceEvent) {
	                                    uResponses.helpers.traceEvent(type, parts[4], parts[5], args);
	                                }
	                                if (_globalSettings.uShowEventsTraceInConsole) uShared._uConsole.log("(E):", parts[4] + "." + parts[5]);
	                            }
	                        }
	                    }
	                }
	                if (uShared._status !== 'notready') {
	                    dumpManager._newRecord(parts);
	                }
	            },
	
	            // build single element info, in format: tag[elementNumber][#id][.class][.class ...]
	            _getElemInfo = function (elem, includeNumber) {
	
	                var elemInfo = elem.tagName.toLowerCase(),
	                    parentChildrenLength,
	                    parentChildrenOrder = 1,
	                    i,
	                    classes = [];
	
	                if ((elem.tagName.toLowerCase() === 'li' || includeNumber) && elem.parentNode) {
	                    parentChildrenLength = elem.parentNode.childNodes.length;
	                    for (i = 0; i < parentChildrenLength; i++) {
	                        if (elem === elem.parentNode.childNodes[i]) {
	                            break;
	                        } else if (elem.parentNode.childNodes[i].nodeType === 1) {
	                            parentChildrenOrder++;
	                        }
	                    }
	                    elemInfo += '[' + parentChildrenOrder + ']';
	                }
	
	                if (elem.className && elem.className.trim) {
	                    classes = elem.className.trim().split(/[ \t\n\r]+/);
	
	                    classes = classes.filter(function (c) {
	                        if (c.indexOf('|') > -1 || c.indexOf('/') > -1 || c.indexOf('#') > -1) return false;
	                        if (_globalSettings.uIgnoreClassNamesWithPrefix) {
	                            for (var i = 0; i < _globalSettings.uIgnoreClassNamesWithPrefix.length; i++) {
	                                if (c.indexOf(_globalSettings.uIgnoreClassNamesWithPrefix[i]) == 0) {
	                                    return false;
	                                }
	                            }
	                        }
	                        return true;
	                    });
	
	                    if (classes.length > 0) {
	                        classes = "." + classes.join('.');
	                    } else {
	                        classes = '';
	                    }
	                }
	                var id =  elem.getAttribute('id') || '';
	                if (_globalSettings.uIgnoreIdsWithPrefix) {
	                    for (var i = 0; i < _globalSettings.uIgnoreIdsWithPrefix.length; i++) {
	                        if (id.indexOf(_globalSettings.uIgnoreIdsWithPrefix[i]) == 0) {
	                            id = '';
	                            break;
	                        }
	                    }
	                }
	                return elemInfo + (id ==='' ? '' : '#') + id + classes;
	
	            },
	
	            // generate path for target element in a css-selector manner, including class names and ids, up to html element
	            // example: html/body/#wrap/#content.wide/article/p.lead.green/a
	            _getPath = function (elem) { /* TODO: order number of element [n] */
	
	                var path = [],
	                    current,
	                    includeNumber = true;
	
	                while (elem.tagName) {
	                    current = _getElemInfo(elem, includeNumber);
	                    path.push(current);
	
	                    // if short names are enabled and current element has the id, break out from loop
	                    if (!_globalSettings.uFullElementBacktrace && current.indexOf('#') > -1) {
	                        break;
	                    }
	
	                    if (elem.parentNode) {
	                        if (elem.parentNode.tagName !== 'HTML') {
	                            if (elem.parentNode instanceof ShadowRoot) {
	                                elem = elem.parentNode.host;
	                            } else {
	                                elem = elem.parentNode;
	                            }
	                        } else {
	                            break
	                        }
	                    }else{
	                        break;
	                    }
	                    //includeNumber = false;
	                }
	                path = path.reverse().join('/');
	                return path;
	            },
	
	            // gets time from beginning of recording to now, in miliseconds
	            _getTimestamp = function (offset) {
	                offset = offset || Date.now();
	                return (offset - parseInt(uShared._sstorage.get('timeOffset'), 10)) || 0;
	            },
	
	            // record full cookie
	            _recordCookies = function () {
	                if (!_globalSettings.uRecordCookies) return;
	
	                if (win.document.cookie) {
	                    var cookie = win.document.cookie.split('; ');
	                    var str = ''
	                    for (var all in cookie) {
	                        if (typeof cookie[all] != 'string') continue;
	                        var c = cookie[all].split('=');
	                        if (_globalSettings.uRecordCookies === true || _globalSettings.uRecordCookies.indexOf(c) > -1) {
	                            str += cookie[all] + "; ";
	                        }
	                    }
	                    _saveRecord('e', _getTimestamp(), 0, 0, '_uJS', 'setCookie', str);
	                }
	                // custom code
	
	                // end of custom code
	
	            }
	
	
	        // methods for extracting data from HTML dom
	
	
	        ///////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	
	        __conditions = [],
	            __triggers = [],
	
	            _triggered = {},
	            _outofsample = {},
	            _inthesample = {},
	
	            _loadTriggers = function () // using JSOPN
	        {
	            uShared._sstorage.set('triggers', 'loading');
	            var triggersURL = 'https://' + _globalSettings.cdnDomain + '/dsdk/' + String(_globalSettings.uPort).substr(0, 2) + '/' + _globalSettings.uPort;
	            if (uShared._sstorage.get('uDebug')) {
	                triggersURL += '/triggersDebug.js';
	                uShared._uConsole.log("uTriggers: Unpublished triggers only.");
	            } else {
	                triggersURL += '/triggers.js';
	            }
	
	            var script = document.createElement("script");
	            script.src = triggersURL + '?rnd=' + Math.random();
	            document.head.appendChild(script);
	
	        },
	
	        handleTriggers = function (o) // public interface avaialble via uDash.handleTriggers required by JSOPN
	        {
	            uShared._sstorage.set('triggers', JSON.stringify(o));
	        },
	
	        _saveTriggerGroup = function (group, o) {
	            var arr = [];
	            for (var all in o) {
	                arr.push(all);
	            }
	            uShared._setCookie(group, arr.join(','));
	        }
	
	        _setupTriggers = function () {
	
	                if (uShared._sstorage.get('triggers') == 'loading') {
	                    return;
	                } else if (uShared._sstorage.get('triggers')) {
	                    win.uTriggers = JSON.parse(uShared._sstorage.get('triggers'));
	                    uShared._uConsole.log("uTriggers: Loading triggers from session storage.");
	                } else {
	                    _loadTriggers();
	                    uShared._uConsole.log("uTriggers: Loading triggers...");
	                    return;
	                }
	
	
	                var convertToObj = function (str) {
	                    var c = str.charAt(0);
	                    if (c === '{') {
	                        return JSON.parse(str);
	                    } else {
	                        var arr = decodeURIComponent(str).split(','),
	                            o = {},
	                            l = arr.length;
	                        for (var i = 0; i < l; i++) {
	                            o[arr[i]] = 1;
	                        }
	                        return o;
	                    }
	                }
	                uDash.saveAttribute('triggersVersion', win.uTriggers.hash);
	
	                __conditions = win.uTriggers.conditions;
	                __triggers = win.uTriggers.triggers;
	
	                for (var i = 0; i < __conditions.length; i++) {
	                    __conditions[i].key = __conditions[i].key.toLowerCase();
	                    __conditions[i].value = __conditions[i].value.toLowerCase();
	                }
	
	                if (uShared._sstorage.get('triggered')) {
	                    _triggered = JSON.parse(uShared._sstorage.get('triggered'));
	                }
	
	                _outofsample = uShared._readCookie('uDashOut');
	                if (!_outofsample && uShared._lstorage.get('out')) {
	                    _outofsample = uShared._lstorage.get('out');
	                }
	                if (!_outofsample) _outofsample = '{}';
	
	                try {
	                    _outofsample = convertToObj(_outofsample)
	                } catch (e) {
	                    _outofsample = {};
	                }
	
	                _inthesample = uShared._readCookie('uDashIn');
	                if (!_inthesample && uShared._lstorage.get('in')) {
	                    _inthesample = uShared._lstorage.get('in');
	                }
	
	                if (!_inthesample) _inthesample = '{}';
	                try {
	                    _inthesample = convertToObj(_inthesample)
	                } catch (e) {
	                    _inthesample = {};
	                }
	                var activeIDs = {};
	
	                var forceGroup = function (idLabel) {
	                    var ids = uShared._sstorage.get(idLabel);
	                    if (ids) {
	
	                        ids = ids.split('|');
	                        for (var i = 0; i < ids.length; i++) {
	                            uShared._uConsole.log('Forcing Trigger ', ids[i], 'into ', idLabel);
	                            activeIDs[ids[i]] = 1;
	                            var baseId = ids[i].split('_')[0];
	                            // delete all alternative versions
	                            for (var id in _inthesample){
	                                if (id.indexOf(baseId)===0){
	                                    delete _inthesample[id];
	                                }
	                            }
	                            if (idLabel === 'testIds') {
	                                _inthesample[ids[i]] = 1;
	                                delete _outofsample[ids[i].split('_')[0]];
	                            } else {
	                                _outofsample[ids[i].split('_')[0]] = 1;
	                                delete _inthesample[ids[i]];
	                            }
	                        }
	                    }
	                }
	
	                forceGroup('testIds');
	                forceGroup('controlIds');
	                // prepare object
	                var triggersO = {};
	                for (var ii = 0; ii < __triggers.length; ii++) {
	                    var tid = __triggers[ii].triggerId+__triggers[ii].v;
	                    triggersO[tid] = ii;
	                }
	                // get lifetime trigger history	 
	                for ( ii = 0; ii < __triggers.length; ii++) { 
	                    var tid = __triggers[ii].triggerId+__triggers[ii].v;
	                    // check if trigger is sampled and unless its id is forced, autoforce all users into test groups
	                    if (!activeIDs[tid]) { // active contains forced ids at that point
	                        if (__triggers[ii].occurrence === 2) { // trigger only once per session 
	                            if (_triggered[tid]) {
	                                __triggers[ii].minMatches = -1;
	                            }
	                        } else if (__triggers[ii].occurrence === 3) { // trigger only once per user
	                            if (_inthesample[tid]) { // disable, cause already matched in one of previous sessions.
	                                __triggers[ii].minMatches = -1;
	                            }
	                        }
	                        if (__triggers[ii].sample === 1 || __triggers[ii].sample === 100) { // reset past group assignment and put user in the test group
	                            delete _outofsample[tid];
	                            if (__triggers[ii].occurrence === 3) _inthesample[tid] = 1; // track full-sample triggers only for life-times.
	                        }
	                        activeIDs[tid] = 1;
	                        activeIDs[tid.split('_')[0]] = 1;
	
	                    } else { // reset history for forced users 
	                        
	                        __triggers[ii].minMatches = 0;
	                    }
	
	                    if (_outofsample[tid]) {
	                        //__triggers[ii].minMatches = -1; // disable, cause already matched in one of previous sessions.
	                        saveAttribute(__triggers[ii].triggerId, 'control');
	                    }
	                    if (_inthesample[tid]) {
	                        if (tid.indexOf('_')>-1){
	                            if (triggersO[__triggers[ii].triggerId]){
	                                __triggers[triggersO[__triggers[ii].triggerId]].versionI = ii;
	                            }
	                        }
	                        saveAttribute(__triggers[ii].triggerId, __triggers[ii].filterset + '/' + __triggers[ii].response+__triggers[ii].v);
	                    }
	                }
	
	                // remove inactive ids
	                for (var id in _inthesample) {
	                    if (!activeIDs[id]) {
	                        delete _inthesample[id];
	                    }
	                }
	                for (var id in _outofsample) {
	                    if (!activeIDs[id]) {
	                        delete _outofsample[id];
	                    }
	                }
	            
	                // save sampling data
	
	                _saveTriggerGroup('uDashIn', _inthesample);
	                _saveTriggerGroup('uDashOut', _outofsample);
	
	                uShared._lstorage.set('out', JSON.stringify(_outofsample));
	                uShared._lstorage.set('in', JSON.stringify(_inthesample));
	
	                _globalSettings.triggers = {
	                    'in': _inthesample,
	                    'out': _outofsample,
	                }
	
	
	            },
	
	            _checkAgainstConditions = function (type, key, val, params) {
	
	                if (type == 'p') return;
	                if (key === null || val === null) return;
	
	                var l = __conditions.length,
	                    event = {
	                        type: type,
	                        key: key,
	                        val: val
	                    },
	                    matched,
	                    keyMatched,
	                    sign,
	                    matchedConditions = [];
	
	                if (key && key.toLowerCase) key = key.toLowerCase();
	                if (val && val.toLowerCase) val = val.toLowerCase();
	
	                if (params) event.params = params;
	
	                for (var i = 0; i < l; i++) {
	
	                    /*if (type!=='a' && __conditions[i].matched==1) {
	                            console.log('already matched',key,val,__conditions[i])
	                            continue; 
	                        }*/
	                    matched = false,
	                    keyMatched = false;
	                    if (type == __conditions[i].type && (key == __conditions[i].key || key.match(__conditions[i].key))) { // a,m
	                        keyMatched = true;
	                        sign = __conditions[i].sign;
	
	                        if (key == 'firstVisit') { // this should be partially moved to server-side, should also work with any dates
	                            var darr = val.split(' ').join('-').split(':').join('-').split('-');
	                            val = new Date(darr[0], darr[1] - 1, darr[2], darr[3], darr[4]);
	                            darr = __conditions[i].value.split(' ').join('-').split(':').join('-').split('-');
	                            __conditions[i].value = new Date(darr[0], darr[1] - 1, darr[2], darr[3], darr[4]);
	                        }
	
	                        if (sign == "=") {
	                            val = String(val);
	                            if (val.match) {
	                                
	                                if (val.match(__conditions[i].value)) matched = true;
	                            } else {
	                                if (val == __conditions[i].value) matched = true;
	                            }
	                        } else if (sign == ">") {
	                            if (val > __conditions[i].value) matched = true;
	                        } else if (sign == ">=") {
	                            if (val >= __conditions[i].value) matched = true;
	                        } else if (sign == "<") {
	                            if (val < __conditions[i].value) matched = true;
	                        } else if (sign == "<=") {
	                            if (val <= __conditions[i].value) matched = true;
	                        }
	                        
	                        if (__conditions[i].type === 'a') {
	                            if (matched) {
	                                __conditions[i].matched = 1;
	                                matchedConditions.push(i);
	                            } else {
	                                __conditions[i].matched = 0;
	                            }
	                        } else if (__conditions[i].type === 'm') {
	                            if (matched) {
	                                __conditions[i].matched = 1;
	                                matchedConditions.push(i);
	                            }
	                        }
	                    } else if ((type == 'e' || type == 'm') && (__conditions[i].type == 'e' || __conditions[i].type == '*')) {
	                        var str = key + "." + val;
	                        if (str.match(__conditions[i].key)) {
	                            __conditions[i].matched = 1;
	                            matchedConditions.push(i);
	                        }
	                    } else if (__conditions[i].key == '^totaltime$') {
	                        var tT = Math.floor(_getTimestamp()/1000);
	                        
	                        sign = __conditions[i].sign;
	                        if (sign == "=") {
	                            if (tT == __conditions[i].value) matched = true;
	                        } else if (sign == ">") {
	                            if (tT > __conditions[i].value) matched = true;
	                        } else if (sign == ">=") {
	                            if (tT >= __conditions[i].value) matched = true;
	                        } else if (sign == "<") {
	                            if (tT < __conditions[i].value) matched = true;
	                        } else if (sign == "<=") {
	                            if (tT <= __conditions[i].value) matched = true;
	                        }
	                        
	                        if (__conditions[i].inclusion === 1) {
	                            if (matched) {
	                                if (!__conditions[i].matched){
	                                    __conditions[i].matched = 1;
	                                    matchedConditions.push(i);
	                                }
	                            } else {
	                                __conditions[i].matched = 0;
	                            }
	                        } else {
	                            if (!matched) {
	                                if (__conditions[i].matched){
	                                    __conditions[i].matched = 1;
	                                    matchedConditions.push(i);
	                                }
	                            } else {
	                                __conditions[i].matched = 0;
	                            }
	                        }
	                    }
	                }
	                for (var i = 0; i < matchedConditions.length; i++) {
	                    _matchedCondition(matchedConditions[i], event);
	                }
	                if (matchedConditions.length > 0) {
	                    _saveTriggers()
	                }
	
	            },
	
	            _matchedCondition = function (i, event) {
	                var matchedCondition = i;
	                var condition = __conditions[matchedCondition];
	                if (!condition.trigger) return;
	
	                var trigger = _getTriggerVersion(condition.triggerId);
	                var l = 0;
	
	                //__conditions[i].matched = 1;
	                if (trigger.minMatches !== -1) { // set for one execution and already executed
	                    var allMatched = true,
	                        ll,
	                        ii;
	                    l = trigger.conditions.length;
	                    if (l > 1) {
	                        for (i = 0; i < l; i++) {
	                            condition = __conditions[trigger.conditions[i]];
	                            if (condition.matched !== condition.inclusion) {
	                                allMatched = false;
	                                if (condition.ORs) {
	                                    ll = condition.ORs.length;
	                                    for (ii = 0; ii < ll; ii++) {
	                                        if (__conditions[condition.ORs[ii]].matched === 1) {
	                                            allMatched = true;
	                                            break;
	                                        }
	                                    }
	                                }
	                                if (!allMatched) break;
	                            }
	                        }
	                    }
	                    if (allMatched) {
	                        // all conditions are met and trigger can be executed
	                        // check if current condition can be a trigger
	                        if (!trigger.triggers || trigger.triggers.indexOf(matchedCondition) > -1) {
	                            if (trigger.occurrence == 1) { // execute every time, reset matchedConditions counter
	
	                            } else { // execute once per user or session
	                                trigger.minMatches = -1;
	                            }
	
	                            _executeTrigger(trigger, event);
	                        }
	                    }
	                }
	
	
	                return true;
	            },
	
	            _setMatchedCondition = function (condition, value) {
	                setTimeout(function () {
	                    __conditions[condition].matched = value;
	                }, 5);
	            },
	
	            _saveTriggers = function () {
	                clearTimeout(this.saveTriggersId);
	                this.saveTriggersId = setTimeout(function () {
	                    uShared._sstorage.set('triggers', JSON.stringify(win.uTriggers));
	                }, 100);
	            },
	            
	            _getTriggerVersion = function (baseTriggerI) {
	                var trigger = __triggers[baseTriggerI];
	                // check if base trigger was assigned or we are in the control group 
	                if (_outofsample[trigger.triggerId]) {
	                    trigger.versionI = baseTriggerI;
	                }
	                if (typeof trigger.versionI !== 'undefined' && trigger.versionI>-1){
	                    return __triggers[trigger.versionI];
	                }
	                
	                var sample = 0;
	                var testSample = 0;
	                var rnd = Math.random();
	                var versionI = baseTriggerI;
	                trigger.versionI = -1;
	            
	                // first calculate control and total sample of all versions
	                for (var i = 0; i<__triggers.length; i++){
	                    if (__triggers[i].triggerId === trigger.triggerId && __triggers[i].filterId === trigger.filterId){
	                        testSample += __triggers[i].sample;
	                    }
	                }
	                rnd = rnd * testSample; // reduce the rnd - if control sample is 25%, then rnd can be max 75%
	                
	                for (var i = 0; i<__triggers.length; i++){
	                    if (__triggers[i].triggerId === trigger.triggerId && __triggers[i].filterId === trigger.filterId){
	                        if (_inthesample[__triggers[i].triggerId+__triggers[i].v] || (trigger.versionI === -1 && rnd<sample+__triggers[i].sample)){
	                            versionI = i;
	                            trigger.versionI = versionI;
	                            break;
	                        }
	                        // the loop needs to run
	                        sample += __triggers[i].sample;
	                    }
	                }
	                
	                __triggers[versionI].sampleV = __triggers[versionI].sample;
	                __triggers[versionI].sample = testSample;
	                return __triggers[versionI];
	            },
	
	            _executeTrigger = function (trigger, event) {
	                if (typeof uResponses == 'undefined') {
	                    // uResponses object is unavailable, check if it is being loaded
	                    var scripts = document.getElementsByTagName('script'),
	                        responsesLoading = false;
	
	                    for (var i = scripts.length; i--;) {
	                        if (scripts[i].src.indexOf("uResponses") > 0) {
	                            responsesLoading = true;
	                            break;
	                        }
	                    }
	                    if (!responsesLoading) {
	                        // load uResponses 
	                        var s = document.createElement("script");
	                        s.type = "text/javascript";
	                        s.src = "https://" + _globalSettings.cdnDomain + "/sdk/" + _globalSettings.uPort + "/uResponses.min.js";
	                        win.document.getElementsByTagName("head")[0].appendChild(s);
	                    }
	                    setTimeout(function () {
	                        _executeTrigger(trigger, event);
	                    }.bind(this), 100);
	                    return;
	                }
	                _triggered[trigger.triggerId] = 1;
	                uShared._sstorage.set('triggered', JSON.stringify(_triggered)); // save triggers triggered 
	                saveMeta('Triggered', trigger.filterset + '/' + trigger.response + trigger.v +'/' + trigger.triggerId);
	                if ((trigger.sampleV < 1) && !_inthesample[trigger.triggerId+ trigger.v] && !_outofsample[trigger.triggerId]) {
	                    // assign user and save
	                    if (Math.random() > trigger.sample) {
	                        saveAttribute(trigger.triggerId, 'control');
	                        _outofsample[trigger.triggerId] = 1;
	                        _saveTriggerGroup('uDashOut', _outofsample);
	                        uShared._lstorage.set('out', JSON.stringify(_outofsample));
	                    } else {
	                        saveAttribute(trigger.triggerId, trigger.filterset + '/' + trigger.response+ trigger.v);
	                        _inthesample[trigger.triggerId+ trigger.v] = 1;
	                        _saveTriggerGroup('uDashIn', _inthesample);
	                        uShared._lstorage.set('in', JSON.stringify(_inthesample));
	                    }
	                }
	
	                if (trigger.sample === 1 || trigger.sample === 100 || _inthesample[trigger.triggerId+ trigger.v]) {
	                    if (typeof trigger.version === 'string' && trigger.version.indexOf('{') === 0) {
	                        trigger.version = JSON.parse(trigger.version);
	                    }
	                    if (typeof trigger.options === 'string') {
	                        trigger.options = JSON.parse(trigger.options);
	                    }
	                    try {
	                        if (trigger.version) {
	                            trigger.version.triggeringEvent = event;
	                            uShared._uConsole.log('In The Sample: Triggered', trigger.filterset + '/' + trigger.response + trigger.v + '/' + trigger.triggerId, 'Triggered by:', trigger.version.triggeringEvent);
	                            win.uResponses.execute(trigger.response, trigger.version, function (e) {
	                                if (e) {
	                                    uShared._uConsole.error('UIB Response', trigger.triggerId+ trigger.v, 'Triggered by:', trigger.version.triggeringEvent, 'Status:', e);
	                                    if (e && e.name == 'Error') {
	                                        saveMeta('Error', trigger.triggerId + " "+ trigger.response+ trigger.v + " " + e.toString());
	                                    }
	                                }
	                            }, trigger.options);
	                        }
	                    } catch (e) {
	                        saveMeta('Error', trigger.triggerId + " "+ trigger.response+ trigger.v + " exec error: " + JSON.stringify(e));
	                    }
	                } else {
	                    uShared._uConsole.log('Out Of The Sample: Triggered', trigger.filterset + '/' + trigger.response+ trigger.v + '/' + trigger.triggerId);
	                    uShared._uConsole.log("uTrigger:", trigger.triggerId, "Not in the sample");
	                }
	            }
	        // Custom code, remember about adding , below
	        //,	
	        // end of custom code
	        // semicolon goes below
	        ;
	
	
	
	
	        // reveal public uRecorder api
	        return {
	            META_ACTION: uShared.META_ACTION,
	            META_SECTION: uShared.META_SECTION,
	            META_ERROR: uShared.META_ERROR,
	            META_SITE_IS_READY: uShared.META_SITE_IS_READY,
	
	            init: init,
	            getSetting: function (name) {
	                return _globalSettings[name] || '';
	            },
	            getStatus: uShared._bindShim(uShared.getStatus, uShared),
	            tearDown: tearDown,
	            saveAttribute: saveAttribute,
	            saveMeta: saveMeta,
	            sendDump: uShared._bindShim(dumpManager.send, dumpManager),
	            connect: uShared._bindShim(dumpManager._connect, dumpManager),
	            handleTriggers: handleTriggers,
	            trackShadowRoot: trackShadowRoot,
	            getElementPath: _getPath
	        };
	
	    }(window)); // end of uRecorder
	
	    return uRecorder;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// udash.min.js